(function () {
  'use strict';
  if (window.FloramePartnerDirectory?.openCompare) return;

  var API_BASE = 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net';
  var DELIVERY_INTENT_KEY = 'florame_delivery_intent_v1';
  var DELIVERY_SCHEDULER_KEY = 'florame_ds_state_v19';
  var CONFIG = Object.assign({
    directoryEndpoint: API_BASE + '/portalPublicPartnerDirectoryV1',
    addressAutocompleteEndpoint: API_BASE + '/addressAutocomplete',
    addressResolveEndpoint: API_BASE + '/addressResolve'
  }, window.__floramePartnerDirectoryConfig || {});

  function readStoredDeliveryIntent() {
    try {
      var sessionOwn = JSON.parse(sessionStorage.getItem(DELIVERY_INTENT_KEY) || '{}') || {};
      var localOwn = JSON.parse(localStorage.getItem(DELIVERY_INTENT_KEY) || '{}') || {};
      var own = sessionOwn.selectedDate || sessionOwn.selectedTimeSlot ? sessionOwn : localOwn;
      var scheduler = JSON.parse(sessionStorage.getItem(DELIVERY_SCHEDULER_KEY) || '{}') || {};
      var snapshot = window.__florameDeliveryIntentSnapshot || {};
      var selectedDate = String(snapshot.selectedDate || own.selectedDate || scheduler.selectedDate || '').slice(0, 10);
      var selectedTimeSlot = String(snapshot.selectedTimeSlot || own.selectedTimeSlot || scheduler.selectedTimeSlot || '').trim().slice(0, 48);
      return {
        deliveryType: String(snapshot.deliveryType || own.deliveryType || 'delivery'),
        selectedDate: /^\d{4}-\d{2}-\d{2}$/.test(selectedDate) ? selectedDate : '',
        selectedTimeSlot: selectedTimeSlot
      };
    } catch (_) {
      return { selectedDate: '', selectedTimeSlot: '' };
    }
  }

  var TEXT = {
    it: {
      kicker: 'Partner Florame',
      title: 'Esplora i fioristi partner',
      subtitle: 'Trova gli atelier che possono preparare o consegnare il bouquet nella tua zona.',
      placeholder: 'Città, CAP o indirizzo di consegna',
      search: 'Cerca',
      near: 'Vicino a me',
      loading: 'Caricamento partner...',
      searching: 'Ricerca partner in corso...',
      all: 'Partner attivi',
      coverage: 'Partner che coprono questo indirizzo',
      city: 'Partner in zona',
      empty: 'Nessun partner trovato per questa ricerca.',
      emptyHint: 'Puoi comunque creare un bouquet e Florame cercherà la migliore copertura disponibile.',
      create: 'Crea bouquet',
      open: 'Apri storefront',
      covers: 'Copre indirizzo',
      pickup: 'Ritiro in negozio',
      delivery: 'Consegna',
      compactKicker: 'Il tuo fiorista',
      compactTitle: 'Un fiorista vicino a te',
      compactSubtitle: 'Scelto in base al tuo indirizzo e alla disponibilità reale.',
      viewAll: 'Vedi altri fioristi',
      collapse: 'Mostra meno',
      stockLive: 'Stock aggiornato',
      stockCoverageLive: 'Consegna disponibile qui',
      stockExpiring: 'Disponibilità da riconfermare',
      stockEmpty: 'Nessun bouquet disponibile ora',
      stockOffline: 'Temporaneamente non disponibile',
      stockUnknown: 'Disponibilità da verificare',
      newOnFlorame: 'Nuovo su florame.ai',
      verifiedOrder: 'ordine verificato',
      verifiedOrders: 'ordini verificati',
      addressError: 'Non riesco a leggere questo indirizzo. Prova con città o CAP.',
      gpsError: 'Posizione non disponibile. Inserisci un indirizzo o una città.',
      disabled: 'Directory partner non attiva.',
      results: 'risultati',
      oneResult: 'risultato',
      roma: 'Roma',
      coverageFallback: 'Copertura verificata su CAP'
      ,
      compareTitle: 'Fioristi che consegnano qui',
      compareTitleNoAddress: 'Confronta i fioristi',
      compareSubtitle: 'Confronta chi può preparare e consegnare il bouquet al destinatario.',
      compareChoiceKicker: 'Scelta del fiorista',
      compareChoiceTitle: 'Vuoi cambiare fiorista?',
      compareChoiceSubtitle: 'Confronta liberamente i partner prima di scegliere con chi continuare.',
      compareCoverageKicker: 'Consegna non coperta',
      compareCoverageTitle: 'Questo fiorista non consegna qui',
      compareCoverageSubtitle: 'Ti mostriamo soltanto i fioristi che possono raggiungere il destinatario.',
      compareProductKicker: 'Bouquet da ritrovare',
      compareProductTitle: 'Troviamone uno davvero acquistabile',
      compareProductSubtitle: 'Questa vecchia versione non è più in vendita. Cerchiamo chi può prepararne una compatibile, senza mandarti su una pagina inesistente.',
      compareProductEmpty: 'Non c’è una copia identica pronta, ma puoi ricreare questo stile.',
      compareOnly: 'È l’unico fiorista Florame che consegna a questo indirizzo.',
      compareOneAlternative: 'Qui consegna un altro fiorista Florame.',
      compareMany: 'Scegli il fiorista più adatto al tuo regalo.',
      compareEmpty: 'Per ora nessun fiorista Florame consegna a questo indirizzo.',
      compareAddressRequired: 'Aggiungi l’indirizzo del destinatario per vedere chi può consegnare.',
      compareAddAddress: 'Aggiungi indirizzo',
      compareClose: 'Chiudi confronto fioristi',
      compareCurrent: 'Stai guardando questo',
      compareChoose: 'Scegli',
      bouquetExact: 'Questo bouquet è disponibile',
      bouquetUnavailable: 'Questo bouquet non è disponibile',
      bouquetUnknown: 'Bouquet da verificare',
      offerKicker: 'Il tuo bouquet',
      offerTitle: 'Scegli il fiorista',
      offerSubtitle: 'Scegli chi lo prepara. Manteniamo dove e quando e verifichiamo il prezzo prima di aggiungerlo.',
      offerDeliveryPill: 'Proposta consegna',
      offerPickupPill: 'Proposta ritiro',
      offerPaymentNote: 'Paghi solo se il fiorista accetta.',
      offerRequestNote: 'Fiori da confermare',
      offerEdit: 'Modifica questo bouquet',
      offerCreateNew: 'Crea un nuovo bouquet',
      offerRecommended: 'Consigliato',
      offerDelivery: 'Consegna al destinatario',
      offerPickup: 'Ritiro in negozio',
      offerAdd: 'Aggiungi al carrello',
      offerAddFrom: 'Acquista da',
      offerRequest: 'Aggiungi al carrello',
      offerRequestFrom: 'Richiedi a',
      offerRequestDetail: 'Da confermare · paghi solo se accetta',
      offerAddDetail: 'Ordinabile · paghi solo se accetta',
      offerChoose: 'Scegli questa opzione',
      offerOne: '1 opzione disponibile',
      offerMany: 'opzioni disponibili',
      offerFloristOne: '1 fiorista disponibile',
      offerFloristMany: 'fioristi disponibili',
      offerModeMany: 'modalità',
      offerEmpty: 'Non è stato possibile verificare una proposta per questa data e modalità. Modifica Dove e quando oppure riprova.',
      offerPricingPreparing: 'Stiamo preparando il prezzo del fiorista.',
      offerPricingPreparingHint: 'Fiori e consegna sono già verificati. Riprova tra pochi secondi.',
      offerRetry: 'Riprova',
      offerGoneKicker: 'Bouquet non più in catalogo',
      offerGoneTitle: 'Ricreiamolo insieme',
      offerGoneSubtitle: 'Riparti dai fiori disponibili per creare il tuo bouquet.',
      offerGoneStatus: 'Questa versione non è più acquistabile.',
      offerNotify: 'Avvisami quando torna',
      offerChangeAddress: 'Modifica dove e quando',
      promotionCart: 'Offerta del fiorista · applicata nel carrello'
    },
    en: {
      kicker: 'Florame partners',
      title: 'Explore partner florists',
      subtitle: 'Find the ateliers that can prepare or deliver a bouquet in your area.',
      placeholder: 'City, ZIP code or delivery address',
      search: 'Search',
      near: 'Near me',
      loading: 'Loading partners...',
      searching: 'Searching partners...',
      all: 'Active partners',
      coverage: 'Partners covering this address',
      city: 'Partners nearby',
      empty: 'No partner found for this search.',
      emptyHint: 'You can still create a bouquet and Florame will look for the best available coverage.',
      create: 'Create bouquet',
      open: 'Open storefront',
      covers: 'Covers address',
      pickup: 'Store pickup',
      delivery: 'Delivery',
      compactKicker: 'Your florist',
      compactTitle: 'A florist near you',
      compactSubtitle: 'Selected using your address and real availability.',
      viewAll: 'See other florists',
      collapse: 'Show less',
      stockLive: 'Stock updated',
      stockCoverageLive: 'Delivery available here',
      stockExpiring: 'Availability needs confirmation',
      stockEmpty: 'No bouquets available now',
      stockOffline: 'Temporarily unavailable',
      stockUnknown: 'Availability to be checked',
      newOnFlorame: 'New on florame.ai',
      verifiedOrder: 'verified order',
      verifiedOrders: 'verified orders',
      addressError: 'I cannot read this address. Try a city or ZIP code.',
      gpsError: 'Location unavailable. Enter an address or city.',
      disabled: 'Partner directory is not active.',
      results: 'results',
      oneResult: 'result',
      roma: 'Rome',
      coverageFallback: 'Coverage checked by ZIP'
      ,
      compareTitle: 'Florists delivering here',
      compareTitleNoAddress: 'Compare florists',
      compareSubtitle: 'Compare who can prepare and deliver the bouquet to the recipient.',
      compareChoiceKicker: 'Florist choice',
      compareChoiceTitle: 'Would you like another florist?',
      compareChoiceSubtitle: 'Compare partners freely before choosing where to continue.',
      compareCoverageKicker: 'Delivery not covered',
      compareCoverageTitle: 'This florist does not deliver here',
      compareCoverageSubtitle: 'We only show florists who can reach the recipient.',
      compareProductKicker: 'Bouquet to rediscover',
      compareProductTitle: 'Let’s find one you can actually buy',
      compareProductSubtitle: 'This older version is no longer on sale. We will find who can prepare a compatible one without sending you to a missing page.',
      compareProductEmpty: 'There is no identical ready-made version, but you can recreate this style.',
      compareOnly: 'This is the only Florame florist delivering to this address.',
      compareOneAlternative: 'Another Florame florist delivers here.',
      compareMany: 'Choose the best florist for your gift.',
      compareEmpty: 'No Florame florist delivers to this address yet.',
      compareAddressRequired: 'Add the recipient address to see who can deliver.',
      compareAddAddress: 'Add address',
      compareClose: 'Close florist comparison',
      compareCurrent: 'You are viewing this',
      compareChoose: 'Choose',
      bouquetExact: 'This bouquet is available',
      bouquetUnavailable: 'This bouquet is unavailable',
      bouquetUnknown: 'Bouquet availability unknown',
      offerKicker: 'Your bouquet',
      offerTitle: 'Choose your florist',
      offerSubtitle: 'Choose who prepares it. We keep your delivery choices and verify the price before adding it.',
      offerDeliveryPill: 'Delivery option',
      offerPickupPill: 'Pickup option',
      offerPaymentNote: 'You pay only if the florist accepts.',
      offerRequestNote: 'Flowers to be confirmed',
      offerEdit: 'Edit this bouquet',
      offerCreateNew: 'Create a new bouquet',
      offerRecommended: 'Recommended',
      offerDelivery: 'Delivery to recipient',
      offerPickup: 'Store pickup',
      offerAdd: 'Add to cart',
      offerAddFrom: 'Buy from',
      offerRequest: 'Add to cart',
      offerRequestFrom: 'Request from',
      offerRequestDetail: 'To be confirmed · pay only if accepted',
      offerAddDetail: 'Orderable · pay only if accepted',
      offerChoose: 'Choose this option',
      offerOne: '1 option available',
      offerMany: 'options available',
      offerFloristOne: '1 florist available',
      offerFloristMany: 'florists available',
      offerModeMany: 'methods',
      offerEmpty: 'No offer could be verified for this date and delivery method. Edit Where and when, or try again.',
      offerPricingPreparing: 'We are preparing the florist price.',
      offerPricingPreparingHint: 'Flowers and delivery are already verified. Try again in a few seconds.',
      offerRetry: 'Try again',
      offerGoneKicker: 'Bouquet no longer in the catalogue',
      offerGoneTitle: 'Let’s recreate it',
      offerGoneSubtitle: 'Start with the available flowers to create your bouquet.',
      offerGoneStatus: 'This version is no longer available to purchase.',
      offerNotify: 'Notify me when available',
      offerChangeAddress: 'Edit where and when',
      promotionCart: 'Florist offer · applied in cart'
    }
  };

  var MOMENT_TEXT = {
    it: {
      dawn: ['Si comincia presto', 'Il giorno sboccia qui', 'Fiori freschi e mani già al lavoro.'],
      morning: ['Buongiorno dai fiori', 'La giornata parte in fiore', 'Scegli il bouquet che ti somiglia.'],
      midday: ['Freschi di giornata', 'Un fiore cambia il pranzo', 'Composizioni disponibili proprio ora.'],
      afternoon: ['Un pensiero al volo', 'Il pomeriggio merita colore', 'Fiori scelti e preparati dal tuo atelier.'],
      sunset: ['Ultimi raggi, nuovi fiori', 'La sera si fa più bella', 'C’è ancora tempo per sorprendere qualcuno.'],
      evening: ['Il negozio non dorme ancora', 'Fiori per domani, emozioni da oggi', 'Esplora con calma e prepara il prossimo gesto.'],
      expiring: ['Manca una piccola conferma', 'Questi fiori potrebbero cambiare', 'Lo stock è quasi da aggiornare.'],
      empty: ['Il vaso aspetta nuovi fiori', 'Nuovi bouquet in arrivo', 'Ora è tutto esaurito, ma torna presto.'],
      offline: ['Uffa, oggi siamo in pausa', 'I fiori riposano un po’', 'Il negozio tornerà dopo il prossimo aggiornamento.'],
      unknown: ['Stiamo guardando tra i fiori', 'Disponibilità in verifica', 'Un controllo veloce e sapremo cosa può fiorire oggi.']
    },
    en: {
      dawn: ['An early start', 'The day blooms here', 'Fresh flowers and hands already at work.'],
      morning: ['Good morning from the flowers', 'Start the day in bloom', 'Choose the bouquet that feels like you.'],
      midday: ['Fresh today', 'A flower changes lunch', 'Arrangements available right now.'],
      afternoon: ['A thoughtful surprise', 'The afternoon deserves colour', 'Flowers chosen by your atelier.'],
      sunset: ['Last light, new flowers', 'Make the evening lovelier', 'There is still time to surprise someone.'],
      evening: ['The shop is still dreaming', "Tomorrow's flowers start today", 'Explore slowly and plan your next gesture.'],
      expiring: ['One quick confirmation needed', 'These flowers may change', 'Stock is nearly due for an update.'],
      empty: ['The vase is waiting', 'New bouquets are coming', 'Sold out for now, but check back soon.'],
      offline: ['Oh no, we are taking a pause', 'The flowers are resting', 'The shop will return after its next update.'],
      unknown: ['Looking among the flowers', 'Checking availability', 'A quick check will tell us what can bloom today.']
    }
  };

  function lang() {
    try {
      if (window.FlorameI18n && typeof window.FlorameI18n.getLanguage === 'function') {
        return window.FlorameI18n.getLanguage() === 'en' ? 'en' : 'it';
      }
      var stored = localStorage.getItem('florame_native_lang') || localStorage.getItem('bouquetLanguage') || '';
      return String(stored || document.documentElement.lang || 'it').slice(0, 2).toLowerCase() === 'en' ? 'en' : 'it';
    } catch (_) {
      return 'it';
    }
  }

  function t(key) {
    var l = lang();
    return (TEXT[l] && TEXT[l][key]) || TEXT.it[key] || key;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function iconSvg(name) {
    var attrs = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';
    var icons = {
      search: '<svg ' + attrs + '><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
      locate: '<svg ' + attrs + '><path d="M12 2v3"/><path d="M12 19v3"/><path d="M2 12h3"/><path d="M19 12h3"/><circle cx="12" cy="12" r="5"/></svg>',
      arrow: '<svg ' + attrs + '><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
      check: '<svg ' + attrs + '><path d="M20 6 9 17l-5-5"/></svg>',
      store: '<svg ' + attrs + '><path d="m3 9 2-5h14l2 5"/><path d="M5 9v10h14V9"/><path d="M9 19v-5h6v5"/><path d="M3 9h18"/><path d="M8 9v3"/><path d="M12 9v3"/><path d="M16 9v3"/></svg>',
      clock: '<svg ' + attrs + '><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
      pin: '<svg ' + attrs + '><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>',
      chat: '<svg ' + attrs + '><path d="M21 11.5a8.5 8.5 0 0 1-12.6 7.4L3 21l2.1-5.4A8.5 8.5 0 1 1 21 11.5Z"/><path d="M8 11h8"/><path d="M8 14h5"/></svg>',
      truck: '<svg ' + attrs + '><path d="M10 17h4"/><path d="M3 6h11v11H3z"/><path d="M14 9h4l3 4v4h-3"/><circle cx="7" cy="17" r="2"/><circle cx="18" cy="17" r="2"/></svg>',
      bell: '<svg ' + attrs + '><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M10 21h4"/></svg>',
      cart: '<svg ' + attrs + '><path d="M6 7h14l-1.4 8.1a2 2 0 0 1-2 1.7H9a2 2 0 0 1-2-1.6L5.2 4H2"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>',
      spark: '<svg ' + attrs + '><path d="M12 3l1.8 5.1L19 10l-5.2 1.9L12 17l-1.8-5.1L5 10l5.2-1.9L12 3z"/><path d="M5 19l.7-2 .8 2 2 .7-2 .8-.8 2-.7-2-2-.8 2-.7z"/></svg>'
    };
    return icons[name] || '';
  }

  function extractCap(value) {
    var match = String(value || '').match(/\b(\d{5})\b/);
    return match ? match[1] : '';
  }

  function normalizeCity(value) {
    return String(value || '')
      .replace(/\b\d{5}\b/g, '')
      .replace(/\b(italia|italy)\b/ig, '')
      .replace(/[,\s]+$/g, '')
      .replace(/^[,\s]+/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isPartnerRoute() {
    try {
      var cfg = window.__florameThemeConfig || {};
      if (/^partner-storefront(?:-v\d+)?$/.test(String(cfg.currentPageTemplateSuffix || ''))) return true;
      var params = new URLSearchParams(window.location.search || '');
      if (params.get('partner') || params.get('partnerSlug')) return true;
      var path = window.location.pathname.replace(/^\/(it|en)(?=\/)/, '');
      var segments = path.split('/').filter(Boolean);
      if (segments.length === 1) {
        var reserved = ['account', 'apps', 'blog', 'blogs', 'cart', 'collections', 'pages', 'products', 'search'];
        return reserved.indexOf(segments[0].toLowerCase()) === -1;
      }
    } catch (_) {}
    return false;
  }

  function endpointUrl(endpoint, query) {
    var url = new URL(endpoint, window.location.origin);
    Object.keys(query || {}).forEach(function (key) {
      var value = query[key];
      if (value === undefined || value === null || value === '') return;
      url.searchParams.set(key, String(value));
    });
    return url.toString();
  }

  async function fetchJson(endpoint, query, signal) {
    var controller = new AbortController();
    var abort = function () { controller.abort(); };
    if (signal?.aborted) abort();
    else signal?.addEventListener('abort', abort, { once: true });
    var timer = window.setTimeout(function () { controller.abort(); }, 20000);
    try {
      var response = await (window.FlorameReadCache?.fetch || window.fetch)(endpointUrl(endpoint, query), {
        cache: query?.bypassCache === '1' ? 'no-store' : 'default',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || data.success === false) throw new Error(data.error || response.statusText || 'request_failed');
      return data;
    } finally {
      window.clearTimeout(timer);
      signal?.removeEventListener('abort', abort);
    }
  }

  function getComponent(components, type) {
    var list = Array.isArray(components) ? components : [];
    for (var i = 0; i < list.length; i += 1) {
      var item = list[i] || {};
      var types = item.types || item.type || [];
      if (!Array.isArray(types)) types = [types];
      if (types.indexOf(type) !== -1) return item.longText || item.long_name || item.shortText || item.short_name || '';
    }
    return '';
  }

  async function resolveAddressQuery(query) {
    var clean = String(query || '').trim();
    if (!clean) return {};
    var directCap = extractCap(clean);
    if (directCap) {
      return { cap: directCap, address: clean, city: normalizeCity(clean) };
    }

    try {
      var sessionToken = 'pd_' + Date.now().toString(36) + Math.random().toString(16).slice(2);
      var autocomplete = await fetchJson(CONFIG.addressAutocompleteEndpoint, {
        q: clean,
        limit: 1,
        country: 'IT',
        sessionToken: sessionToken
      });
      var list = Array.isArray(autocomplete.suggestions) ? autocomplete.suggestions : [];
      var first = list[0] || null;
      if (first && first.placeId) {
        var resolved = await fetchJson(CONFIG.addressResolveEndpoint, {
          placeId: first.placeId,
          country: 'IT',
          sessionToken: sessionToken
        });
        var place = resolved.place || {};
        var display = String(place.formattedAddress || place.display || first.text || clean).trim();
        var cap = extractCap(place.postcode || place.postalCode || display);
        var city = getComponent(place.addressComponents, 'locality')
          || getComponent(place.addressComponents, 'postal_town')
          || getComponent(place.addressComponents, 'administrative_area_level_3')
          || normalizeCity(display);
        return {
          cap: cap,
          city: normalizeCity(city),
          address: display,
          lat: place.lat || '',
          lng: place.lng || ''
        };
      }
    } catch (_) {}

    return { city: normalizeCity(clean), address: clean };
  }

  function readSavedCapState() {
    try {
      var state = JSON.parse(localStorage.getItem('florame_cap_state') || '{}');
      if (!state || !(state.verified || state.addressVerified) || !state.cap) return null;
      var ts = Number(state.ts || state.savedAt || 0);
      if (ts && Date.now() - ts > 2 * 60 * 60 * 1000) return null;
      return { cap: String(state.cap || ''), address: String(state.display || state.address || state.cap || '') };
    } catch (_) {
      return null;
    }
  }

  function initials(name) {
    return String(name || 'F')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (part) { return part.charAt(0).toUpperCase(); })
      .join('') || 'F';
  }

  function statusText(data) {
    var q = data && data.query ? data.query : {};
    var total = Number(data && data.total || 0);
    var countLabel = total === 1 ? t('oneResult') : t('results');
    if (q.mode === 'coverage') return t('coverage') + ' - ' + total + ' ' + countLabel;
    if (q.mode === 'city') return t('city') + (q.city ? ' - ' + String(q.city) : '') + ' - ' + total + ' ' + countLabel;
    if (q.mode === 'search') return t('all') + ' - ' + total + ' ' + countLabel;
    return t('all') + ' - ' + total + ' ' + countLabel;
  }

  function safeAccent(value) {
    var clean = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(clean) ? clean : '#d92f68';
  }

  function availabilityState(partner) {
    var state = String(partner && partner.availability && partner.availability.state || 'unknown').toLowerCase();
    return ['live', 'expiring', 'empty', 'offline'].indexOf(state) !== -1 ? state : 'unknown';
  }

  function availabilityLabel(partner, mode) {
    var state = availabilityState(partner);
    if (state === 'live' && mode === 'coverage' && partner.coversAddress && partner.deliveryEnabled) return t('stockCoverageLive');
    if (state === 'live') return t('stockLive');
    if (state === 'expiring') return t('stockExpiring');
    if (state === 'empty') return t('stockEmpty');
    if (state === 'offline') return t('stockOffline');
    return t('stockUnknown');
  }

  function reviewAggregate(partner) {
    if (!partner || typeof partner !== 'object') return null;
    var source = partner.reviewAggregate
      || partner.reviewsAggregate
      || partner.reputation && (partner.reputation.aggregate || partner.reputation)
      || partner.reviewStats
      || null;
    if (!source || typeof source !== 'object') return null;
    return {
      average: Math.max(0, Math.min(5, Number(source.average || source.averageRating || source.rating || 0) || 0)),
      count: Math.max(0, Math.round(Number(source.ratingCount || source.reviewCount || source.count || source.total || 0) || 0))
    };
  }

  function reviewLabel(partner) {
    var aggregate = reviewAggregate(partner);
    if (!aggregate) return '';
    if (!aggregate.count) return t('newOnFlorame');
    if (aggregate.count < 5 || !aggregate.average) {
      return aggregate.count + ' ' + t(aggregate.count === 1 ? 'verifiedOrder' : 'verifiedOrders');
    }
    var locale = lang() === 'en' ? 'en-US' : 'it-IT';
    return '★ ' + aggregate.average.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
      + ' · ' + aggregate.count + ' ' + t(aggregate.count === 1 ? 'verifiedOrder' : 'verifiedOrders');
  }

  function resolveCardMoment(partner) {
    var state = availabilityState(partner);
    var key = ['expiring', 'empty', 'offline', 'unknown'].indexOf(state) !== -1 ? state : '';
    if (!key) {
      var hour = new Date().getHours();
      if (hour >= 5 && hour < 8) key = 'dawn';
      else if (hour < 11) key = 'morning';
      else if (hour < 14) key = 'midday';
      else if (hour < 18) key = 'afternoon';
      else if (hour < 21) key = 'sunset';
      else key = 'evening';
    }
    var locale = lang();
    var copy = MOMENT_TEXT[locale][key] || MOMENT_TEXT.it[key];
    var assets = window.__florameThemeConfig && window.__florameThemeConfig.partnerCardAssets || {};
    return { key: key, eyebrow: copy[0], title: copy[1], body: copy[2], assetUrl: assets[key] || '', dark: key === 'evening' || key === 'offline' };
  }

  // Pickup is a shop choice, not a delivery coverage or live-stock guarantee.
  var pickupPublicProfiles = new Map();
  function pickupHours(partner) {
    partner = { ...partner, ...(pickupPublicProfiles.get(partner.partnerSlug) || {}) };
    var summary = window.FlorameDeliveryPromise?.openingHoursSummary(partner, readStoredDeliveryIntent().selectedDate, lang()) || {day:floristCopy('Orari del negozio','Shop hours'),value:floristCopy('Orari non comunicati','Hours not provided'),weekly:[]};
    return Object.assign({}, summary, {weekly:summary.weekly.map(function (row) { return '<div><dt>' + escapeHtml(row.day) + '</dt><dd>' + escapeHtml(row.value) + '</dd></div>'; }).join('')});
  }
  function pickupShopCard(partner) {
    partner = { ...partner, ...(pickupPublicProfiles.get(partner.partnerSlug) || {}) };
    var hours = pickupHours(partner);
    var hoursKnown = Object.prototype.hasOwnProperty.call(partner, 'openingHours');
    var maps = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent([partner.name,partner.addressLine || partner.city].filter(Boolean).join(', '));
    var phone = String(partner.phone || '').replace(/[^+\d]/g, '').slice(0,20);
    var promotion = window.FloramePromotions?.labels(partner, { deliveryEligible: false })?.discount || '';
    var promotionBadges = window.FloramePromotions?.badges(partner, { deliveryEligible: false, compact: true }) || '';
    var logo = '';
    try { var url = new URL(partner.logoUrl, window.location.origin); if (partner.logoUrl && /^https?:$/.test(url.protocol)) logo = url.href; } catch (_) {}
    return '<article class="florame-pickup-shop" data-pickup-shop="' + escapeHtml(partner.partnerSlug) + '">' +
      '<div class="florame-pickup-shop__head"><span class="florame-pickup-shop__logo" aria-hidden="true">' + (logo ? '<img src="' + escapeHtml(logo) + '" alt="" width="48" height="48" loading="lazy" decoding="async">' : escapeHtml(initials(partner.name))) + '</span><div class="florame-pickup-shop__identity"><div class="florame-pickup-shop__title"><h3>' + escapeHtml(partner.name || floristCopy('Fiorista', 'Florist')) + '</h3>' + promotionBadges + '</div><p>' + escapeHtml(partner.addressLine || partner.city || '') + '</p></div></div>' +
      (hoursKnown ? '<div class="florame-pickup-shop__hours" data-pickup-hours>' + iconSvg('clock') + '<div><span>' + escapeHtml(hours.hasHours ? hours.day : floristCopy('Orari del negozio','Shop hours')) + '</span><strong>' + escapeHtml(hours.value) + '</strong>' + (hours.exceptional ? '<small>' + escapeHtml(floristCopy('Orario speciale', 'Special hours')) + '</small>' : '') + '</div></div>' : '') +
      '<button type="button" class="florame-pickup-shop__select" data-pickup-select data-partner-slug="' + escapeHtml(partner.partnerSlug) + '" aria-label="' + escapeHtml(floristCopy('Scegli per il ritiro: ', 'Choose for pickup: ') + partner.name) + '"><span>' + escapeHtml(floristCopy('Scegli questo negozio', 'Choose this shop')) + '</span>' + iconSvg('arrow') + '</button>' +
      '<details><summary>' + escapeHtml(floristCopy('Orari e contatti', 'Hours & contact')) + '</summary><dl class="florame-pickup-shop__weekly">' + hours.weekly + '</dl><div class="florame-pickup-shop__links"><a href="' + escapeHtml(maps) + '" target="_blank" rel="noopener noreferrer">' + iconSvg('pin') + escapeHtml(floristCopy('Indicazioni', 'Directions')) + '</a>' + (phone ? '<a href="tel:' + escapeHtml(phone) + '">' + escapeHtml(floristCopy('Chiama', 'Call')) + '</a>' : '') + '</div>' +
      (promotion ? '<p>' + escapeHtml(floristCopy('Offerta applicata nel carrello ai prodotti idonei.', 'Offer applied to eligible products in your cart.')) + '</p>' : '') + '</details></article>';
  }

  function partnerCard(partner, mode, options) {
    if (partner.manualFallback || partner.partnerSlug === window.FlorameLocalFlorist?.slug) partner = Object.assign({}, partner, {logoUrl:window.FlorameLocalFlorist?.identity(partner).logoUrl || partner.logoUrl});
    var compact = !!(options && options.compact);
    var currentSlug = String(options && options.currentSlug || '').toLowerCase();
    var rowSlug = String(partner && partner.partnerSlug || '').toLowerCase();
    var isCurrent = !!currentSlug && rowSlug === currentSlug;
    var href = partner.homeUrl || '/';
    var logo = partner.logoUrl
      ? '<img src="' + escapeHtml(partner.logoUrl) + '" alt="' + escapeHtml(partner.name || '') + '" loading="lazy" decoding="async">'
      : '<span>' + escapeHtml(initials(partner.name)) + '</span>';
    var promotionHtml = window.FloramePromotions?.badges(partner, {deliveryEligible:mode === 'coverage' && partner.coversAddress === true && partner.deliveryEnabled === true}) || '';
    var badges = [];
    if (mode === 'coverage' && partner.coversAddress) badges.push(t('covers'));
    if (partner.pickupEnabled) badges.push(t('pickup'));
    if (partner.deliveryEnabled) badges.push(t('delivery'));
    (Array.isArray(partner.badges) ? partner.badges : []).slice(0, 2).forEach(function (badge) { badges.push(badge); });
    var badgeHtml = badges.slice(0, 3).map(function (badge, index) {
      return '<span class="florame-partner-directory-badge ' + (index === 0 ? 'is-primary' : '') + '">' + (index === 0 ? iconSvg('check') : '') + '<span>' + escapeHtml(badge) + '</span></span>';
    }).join('');
    var localityParts = [partner.city, partner.province || partner.region].filter(function (value, index, values) {
      var normalized = String(value || '').trim().toLowerCase();
      return normalized && values.findIndex(function (candidate) {
        return String(candidate || '').trim().toLowerCase() === normalized;
      }) === index;
    });
    var meta = compact
      ? localityParts.join(' · ')
      : [partner.city, partner.coverageSummary].filter(Boolean).join(' · ');
    var description = partner.servicePromise || partner.description || partner.addressLine || meta || t('coverageFallback');
    var purchaseOffer = options && options.purchaseOffer;
    var requestOrder = purchaseOffer && String(purchaseOffer.effectiveAction || purchaseOffer.fulfillmentOffer?.effectiveAction || purchaseOffer.fulfillmentOffer?.mode || '') === 'request';
    var state = purchaseOffer ? (requestOrder ? 'request' : 'available') : availabilityState(partner);
    var serviceLabels = [partner.deliveryEnabled ? t('delivery') : '', partner.pickupEnabled ? t('pickup') : ''].filter(Boolean);
    var moment = resolveCardMoment(partner);
    var reputation = reviewLabel(partner);
    var bouquetMatchState = String(partner && partner.bouquetMatch && partner.bouquetMatch.state || '');
    var bouquetMatch = bouquetMatchState
      ? '<span class="florame-partner-directory-bouquet-match is-' + escapeHtml(bouquetMatchState) + '">' +
          escapeHtml(t(bouquetMatchState === 'exact'
            ? 'bouquetExact'
            : (bouquetMatchState === 'unavailable' ? 'bouquetUnavailable' : 'bouquetUnknown'))) +
        '</span>'
      : '';
    var cardTag = purchaseOffer ? 'button' : (isCurrent ? 'div' : 'a');
    var navigationAttributes = purchaseOffer
      ? ' type="button" data-florame-offer-index="' + options.offerIndex + '" aria-label="' + escapeHtml(t('compareChoose') + ': ' + (partner.name || '') + ' · ' + t(purchaseOffer.fulfillmentType === 'pickup' ? 'offerPickup' : 'offerDelivery')) + '"'
      : isCurrent
      ? ' aria-current="true"'
      : ' href="' + escapeHtml(href) + '" aria-label="' + escapeHtml(t('compareChoose') + ': ' + (partner.name || '')) + '"';

    return '' +
      '<' + cardTag + ' class="florame-partner-directory-item is-' + escapeHtml(state) + ' is-moment-' + escapeHtml(moment.key) + (moment.dark ? ' is-dark-moment' : '') + (compact ? ' is-compact' : '') + (isCurrent ? ' is-current-partner' : '') + (bouquetMatchState ? ' has-bouquet-match' : '') + '" data-partner-slug="' + escapeHtml(rowSlug) + '" style="--fpd-partner-accent:' + escapeHtml(safeAccent(partner.accentColor)) + ';--fpd-card-art:url(&quot;' + escapeHtml(moment.assetUrl) + '&quot;)"' + navigationAttributes + '>' +
        '<span class="florame-partner-directory-art" aria-hidden="true"></span>' +
        '<span class="florame-partner-directory-content">' +
          '<span class="florame-partner-directory-brand"><span class="florame-partner-directory-logo">' + logo + '</span><span><strong>' + escapeHtml(partner.name || '') + '</strong><em>' + escapeHtml(meta || partner.city || '') + '</em></span></span>' +
          promotionHtml +
          '<span class="florame-partner-directory-moment"><small>' + escapeHtml(moment.eyebrow) + '</small><b>' + escapeHtml(moment.title) + '</b><span>' + escapeHtml(partner.servicePromise || moment.body || description) + '</span></span>' +
          '<span class="florame-partner-directory-availability is-' + escapeHtml(state) + '"><i aria-hidden="true"></i>' + escapeHtml(purchaseOffer ? floristCopy(requestOrder ? 'Su richiesta' : 'Ordinabile', requestOrder ? 'By request' : 'Available to order') : availabilityLabel(partner, mode)) + '</span>' +
          (reputation ? '<span class="florame-partner-directory-reputation">' + escapeHtml(reputation) + '</span>' : '') +
          bouquetMatch +
          (isCurrent ? '<span class="florame-partner-directory-current">' + iconSvg('check') + '<span>' + escapeHtml(t('compareCurrent')) + '</span></span>' : '') +
          (compact && serviceLabels.length ? '<span class="florame-partner-directory-services">' + escapeHtml(serviceLabels.join(' · ')) + '</span>' : '') +
          (!compact ? '<span class="florame-partner-directory-badges">' + badgeHtml + '</span>' : '') +
          (purchaseOffer ? purchaseOfferSummary(purchaseOffer, partner) : '') +
        '</span>' +
        (!isCurrent && !purchaseOffer ? '<span class="florame-partner-directory-arrow" aria-hidden="true">' + iconSvg('arrow') + '</span>' : '') +
      '</' + cardTag + '>';
  }

  function purchaseOfferSummary(offer, partner) {
    var pickup = offer.fulfillmentType === 'pickup';
    var cents = Number(offer.pricing?.listPriceCents || offer.price?.priceAmountCents || 0);
    var price = window.FloramePromotions?.priceHtml(cents, partner, 'bouquets', {matched:true,deliveryEligible:!pickup})
      || escapeHtml(new Intl.NumberFormat(lang() === 'en' ? 'en-GB' : 'it-IT', {style:'currency',currency:offer.price?.currency || 'EUR'}).format(cents / 100));
    return '<span class="florame-partner-directory-purchase"><span>' + iconSvg(pickup ? 'store' : 'truck') + '<b>' + escapeHtml(t(pickup ? 'offerPickup' : 'offerDelivery')) + '</b></span><strong>' + price + '</strong><em>' + escapeHtml(offer.fulfillmentOffer?.customerCopy?.[lang()]?.detail || t('offerPaymentNote')) + '</em><span class="florame-partner-directory-purchase-action">' + escapeHtml(floristCopy('Scegli e aggiungi al carrello', 'Choose and add to cart')) + iconSvg('arrow') + '</span></span>';
  }

  function bouquetOrderIssue(resolution) {
    if (resolution?.bouquetFound === false || resolution?.state === 'bouquet_missing') return floristCopy('I dati di questo bouquet non sono più disponibili. Scegli un altro bouquet oppure componine uno nuovo.', 'This bouquet’s data is no longer available. Choose another bouquet or compose a new one.');
    if (['composition_missing','composition_invalid'].includes(resolution?.state)) return floristCopy('La composizione del bouquet non è disponibile. Componi un nuovo bouquet per continuare.', 'This bouquet’s composition is unavailable. Compose a new bouquet to continue.');
    if (['commerce_missing','commerce_unavailable'].includes(resolution?.state) || resolution?.commerce?.sellable === false) return floristCopy('Il prodotto di questo bouquet non è disponibile per l’acquisto. Riparti dalla composizione per generare una nuova anteprima.', 'This bouquet’s product is unavailable for purchase. Generate a new preview from its composition.');
    if (resolution?.outOfSeason) return floristCopy('Questo bouquet contiene fiori fuori stagione. Modifica la composizione per continuare.', 'This bouquet contains flowers that are out of season. Edit its composition to continue.');
    return '';
  }

  function includeQaFixtures() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return ['1', 'true', 'yes'].indexOf(String(params.get('qaPartners') || params.get('florameQaPartners') || '').toLowerCase()) !== -1;
    } catch (_) {
      return false;
    }
  }

  function groupOffersByPartner(offers) {
    var groups = [];
    var byPartner = new Map();
    (Array.isArray(offers) ? offers : []).forEach(function (offer, index) {
      var partner = offer && offer.partner || {};
      var key = String(partner.partnerSlug || partner.id || partner.name || 'partner-' + index).trim().toLowerCase();
      var group = byPartner.get(key);
      if (!group) {
        group = { partner: partner, offers: [] };
        byPartner.set(key, group);
        groups.push(group);
      }
      group.offers.push({ offer: offer, index: index });
    });
    return groups;
  }

  var offerResolutionCache = window.__floramePartnerOfferResolutionCache instanceof Map
    ? window.__floramePartnerOfferResolutionCache
    : new Map();
  var offerResolutionInflight = window.__floramePartnerOfferResolutionInflight instanceof Map
    ? window.__floramePartnerOfferResolutionInflight
    : new Map();
  window.__floramePartnerOfferResolutionCache = offerResolutionCache;
  window.__floramePartnerOfferResolutionInflight = offerResolutionInflight;

  async function resolveOffers(detail) {
    var info = detail && typeof detail === 'object' ? detail : {};
    var saved = readSavedCapState() || {};
    var productIds = Array.from(new Set(
      (Array.isArray(info.productIds) ? info.productIds : [info.productId])
        .map(function (value) { return String(value || '').trim(); })
        .filter(Boolean)
    )).slice(0, 24);
    if (!productIds.length) return { resolutions: {}, resolution: null };
    var cap = String(info.cap || saved.cap || '').trim();
    var address = String(info.address || info.display || saved.address || '').trim();
    var currentSlug = currentPartnerSlug(info);
    var deliveryIntent = readStoredDeliveryIntent();
    try {
      deliveryIntent = Object.assign(deliveryIntent, window.FlorameDeliveryIntent?.toQuery?.() || {});
    } catch (_) {}
    var qaFixtures = includeQaFixtures();
    var bypassCache = info.bypassCache === true;
    var city = String(deliveryIntent.city || info.city || saved.city || '').trim();
    // Cache only on request inputs. Commercial mode, request kind and policy
    // revision are outputs of this endpoint: including them would invalidate
    // the cache after every response and create a refresh loop.
    var intentSignature = [
      deliveryIntent.deliveryType || info.deliveryType || 'delivery',
      deliveryIntent.selectedDate || info.selectedDate || 'no-date',
      deliveryIntent.selectedTimeSlot || info.selectedTimeSlot || 'no-slot',
      deliveryIntent.postalCode || cap || 'no-address',
      deliveryIntent.latitude || info.lat || '',
      deliveryIntent.longitude || info.lng || ''
    ].join('|');
    var cacheKey = [productIds.join(','), cap, address, city, currentSlug, intentSignature, qaFixtures ? 'qa' : 'live'].join('|');
    var cached = bypassCache ? null : offerResolutionCache.get(cacheKey);
    if (cached && Date.now() - cached.savedAt < 10000 && (!cached.data?.readCache || cached.data.readCache.validUntil > Date.now())) return cached.data;
    var flightKey = cacheKey + (bypassCache ? '|force' : '');
    var inflight = offerResolutionInflight.get(flightKey);
    if (inflight) return inflight;
    var request = fetchJson(CONFIG.directoryEndpoint, {
      mode: 'compare',
      cap: cap,
      address: address,
      city: city,
      lat: info.lat || '',
      lng: info.lng || '',
      productIds: productIds.join(','),
      currentPartnerSlug: currentSlug,
      deliveryType: deliveryIntent.deliveryType || info.deliveryType || 'delivery',
      selectedDate: deliveryIntent.selectedDate || info.selectedDate || '',
      selectedTimeSlot: deliveryIntent.selectedTimeSlot || info.selectedTimeSlot || '',
      postalCode: deliveryIntent.postalCode || cap,
      latitude: deliveryIntent.latitude || info.lat || '',
      longitude: deliveryIntent.longitude || info.lng || '',
      includeQaFixtures: qaFixtures ? '1' : '',
      clientRevision: 'storefront-v588',
      bypassCache: bypassCache ? '1' : '',
      limit: 40
    }).then(function (data) {
      offerResolutionCache.set(cacheKey, { savedAt: Date.now(), data: data });
      return data;
    }).finally(function () {
      offerResolutionInflight.delete(flightKey);
    });
    offerResolutionInflight.set(flightKey, request);
    return request;
  }

  function shell(surface) {
    var compactHome = surface === 'app-home';
    return '' +
      '<article class="florame-partner-directory-card' + (compactHome ? ' is-compact-home' : '') + '" data-partner-directory-card>' +
        '<div class="florame-partner-directory-head">' +
          '<div>' +
            '<div class="florame-partner-directory-kicker">' + escapeHtml(t(compactHome ? 'compactKicker' : 'kicker')) + '</div>' +
            '<h2>' + escapeHtml(t(compactHome ? 'compactTitle' : 'title')) + '</h2>' +
            '<p>' + escapeHtml(t(compactHome ? 'compactSubtitle' : 'subtitle')) + '</p>' +
          '</div>' +
          '<div class="florame-partner-directory-mark" aria-hidden="true">' +
            '<svg viewBox="0 0 120 120" fill="none" focusable="false">' +
              '<path d="M18 51 60 27l42 24-42 24-42-24Z" fill="rgba(255,255,255,.92)" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M26 57v26l34 19 34-19V57" fill="rgba(255,77,117,.11)" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M60 75v27" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M42 49h36" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M48 40h24" stroke="currentColor" stroke-width="5"/>' +
              '<path d="M87 24l3-8 3 8 8 3-8 3-3 8-3-8-8-3 8-3Z" fill="currentColor"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<form class="florame-partner-directory-search" data-partner-directory-form>' +
          '<label class="florame-partner-directory-field">' +
            '<span class="sr-only">' + escapeHtml(t('placeholder')) + '</span>' +
            '<input type="text" autocomplete="street-address" inputmode="text" placeholder="' + escapeHtml(t('placeholder')) + '" data-partner-directory-input>' +
          '</label>' +
          '<button type="submit" class="florame-partner-directory-button is-search"><span class="florame-partner-directory-button-icon">' + iconSvg('search') + '</span><span>' + escapeHtml(t('search')) + '</span></button>' +
          '<button type="button" class="florame-partner-directory-button is-geo" data-partner-directory-geo><span class="florame-partner-directory-button-icon">' + iconSvg('locate') + '</span><span>' + escapeHtml(t('near')) + '</span></button>' +
        '</form>' +
        '<div class="florame-partner-directory-status" data-partner-directory-status>' + escapeHtml(t('loading')) + '</div>' +
        '<div class="florame-partner-directory-results" data-partner-directory-results data-surface="' + escapeHtml(surface || '') + '"></div>' +
        (compactHome ? '<button type="button" class="florame-partner-directory-expand" data-partner-directory-expand aria-expanded="false">' + escapeHtml(t('viewAll')) + '</button>' : '') +
      '</article>';
  }

  function renderLoading(root, message) {
    var status = root.querySelector('[data-partner-directory-status]');
    var results = root.querySelector('[data-partner-directory-results]');
    if (status) status.textContent = message || t('loading');
    if (results) {
      var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
      var skeletonCount = surface === 'app-home' && root.getAttribute('data-directory-expanded') !== 'true' ? 1 : 3;
      results.innerHTML = Array.from({ length: skeletonCount }).map(function () {
        return surface === 'app-home' ? window.FlorameSkeletons.directoryCompact : window.FlorameSkeletons.directory;
      }).join('');
    }
  }

  function isSurfaceEnabled(root, data) {
    var settings = data && data.partnerDirectorySettings ? data.partnerDirectorySettings : {};
    if (data && data.enabled === false) return false;
    if (settings && settings.enabled === false) return false;
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    if (surface === 'landing') return !settings || settings.landingEnabled !== false;
    if (surface === 'app-home') return !settings || settings.appHomeEnabled !== false;
    return true;
  }

  function renderData(root, data) {
    var status = root.querySelector('[data-partner-directory-status]');
    var results = root.querySelector('[data-partner-directory-results]');
    var section = root.closest('[data-florame-partner-directory-section]');
    if (!isSurfaceEnabled(root, data)) {
      root.hidden = true;
      if (section) section.hidden = true;
      return;
    }
    root.hidden = false;
    if (section) section.hidden = false;
    root.__floramePartnerDirectoryData = data || {};
    if (status) status.textContent = statusText(data || {});
    var partners = Array.isArray(data && data.partners) ? data.partners : [];
    var mode = data && data.query ? data.query.mode : 'all';
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    var compactHome = surface === 'app-home' && root.getAttribute('data-directory-expanded') !== 'true';
    if (compactHome) partners = partners.filter(function (partner) {
      return !partner.visibility || partner.visibility.homeFeatured !== false;
    }).slice(0, 1);
    if (!results) return;
    if (!partners.length) {
      results.innerHTML = '' +
        '<div class="florame-partner-directory-empty">' +
          '<strong>' + escapeHtml(t('empty')) + '</strong>' +
          '<span>' + escapeHtml(t('emptyHint')) + '</span>' +
          '<a href="/pages/florame-app?mode=create">' + escapeHtml(t('create')) + '</a>' +
        '</div>';
      return;
    }
    results.innerHTML = partners.map(function (partner) { return partnerCard(partner, mode, { compact: compactHome }); }).join('');
  }

  async function loadDirectory(root, params, message) {
    try {
      renderLoading(root, message || t('loading'));
      var data = await fetchJson(CONFIG.directoryEndpoint, Object.assign({
        limit: 12,
        includeQaFixtures: includeQaFixtures() ? '1' : ''
      }, params || {}));
      renderData(root, data);
    } catch (error) {
      var status = root.querySelector('[data-partner-directory-status]');
      var results = root.querySelector('[data-partner-directory-results]');
      if (status) status.textContent = t('addressError');
      if (results) results.innerHTML = '';
    }
  }

  var compareSheet = null;
  var compareLastFocus = null;
  var compareBodyOverflow = '';
  var comparePendingDetail = null;
  var compareCurrentDetail = null;
  var compareTransitionSequence = 0;

  function currentPartnerSlug(detail) {
    var explicit = String(detail && (detail.currentPartnerSlug || detail.partnerSlug) || '').trim();
    if (explicit) return explicit.toLowerCase();
    try {
      var params = new URLSearchParams(window.location.search || '');
      var fromQuery = params.get('partner') || params.get('partnerSlug') || '';
      if (fromQuery) return String(fromQuery).toLowerCase();
      var context = window.FloramePartner && window.FloramePartner.getContext
        ? window.FloramePartner.getContext()
        : null;
      return String(context && (context.partnerSlug || context.slug) || '').toLowerCase();
    } catch (_) {
      return '';
    }
  }

  function ensureCompareSheet() {
    if (compareSheet && document.documentElement.contains(compareSheet)) return compareSheet;
    var overlay = document.createElement('div');
    overlay.className = 'florame-partner-compare';
    overlay.hidden = true;
    overlay.innerHTML = '' +
      '<button class="florame-partner-compare-backdrop" type="button" data-partner-compare-close aria-label="' + escapeHtml(t('compareClose')) + '"></button>' +
      '<section class="florame-partner-compare-sheet" role="dialog" aria-modal="true" aria-labelledby="florame-partner-compare-title">' +
        '<div class="florame-partner-compare-handle" data-partner-compare-handle aria-hidden="true"><span></span></div>' +
        '<header class="florame-partner-compare-head">' +
          '<div><button type="button" class="florame-florist-back" data-florist-back hidden></button><span class="florame-partner-compare-kicker" data-partner-compare-kicker>Florame</span><h2 id="florame-partner-compare-title"></h2><p data-partner-compare-subtitle></p></div>' +
          '<button class="florame-partner-compare-close" type="button" data-partner-compare-close aria-label="' + escapeHtml(t('compareClose')) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg></button>' +
        '</header>' +
        '<div class="florame-partner-compare-context" data-partner-compare-context></div>' +
        '<div class="florame-partner-compare-status" data-partner-compare-status aria-live="polite"></div>' +
        '<div class="florame-partner-compare-results" data-partner-compare-results></div>' +
      '</section>';
    document.body.appendChild(overlay);
    compareSheet = overlay;

    function closeCompare(options) {
      if (!compareSheet || compareSheet.hidden || !compareSheet.classList.contains('is-open')) return;
      compareSheet.__pickupSearchCleanup?.();
      var continuation = options && options.continuation === true;
      if (!continuation) comparePendingDetail = null;
      var closedDetail = compareCurrentDetail;
      var closeSequence = ++compareTransitionSequence;
      compareSheet.classList.remove('is-open');
      window.setTimeout(function () {
        if (!compareSheet || closeSequence !== compareTransitionSequence || compareSheet.classList.contains('is-open')) { options?.onClosed?.(false); return; }
        compareSheet.hidden = true;
        document.body.style.overflow = compareBodyOverflow;
        if (options?.restoreFocus !== false && compareLastFocus && typeof compareLastFocus.focus === 'function') compareLastFocus.focus();
        if (!continuation) {
          closedDetail?.onDismiss?.();
          window.dispatchEvent(new CustomEvent('florame:partner-compare-closed', {
            detail: closedDetail || {}
          }));
        }
        if (compareCurrentDetail === closedDetail) compareCurrentDetail = null;
        options?.onClosed?.(true);
      }, compareSheet.__florameBottomSheetOwnerClosePending ? 0 : 220);
    }

    overlay.querySelectorAll('[data-partner-compare-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeCompare(); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && compareSheet && !compareSheet.hidden) closeCompare();
      if (event.key !== 'Tab' || !overlay.classList.contains('is-open')) return;
      var stops = Array.from(overlay.querySelectorAll('[role="dialog"] a[href], [role="dialog"] button:not(:disabled), [role="dialog"] summary, [role="dialog"] input')).filter(function (el) { return el.getClientRects().length > 0; });
      var first = stops[0], last = stops[stops.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    });
    overlay.__closeFlorameCompare = closeCompare;
    return overlay;
  }

  function floristCopy(it, en) { return lang() === 'en' ? en : it; }

  function floristShopUrl(profile) {
    if (profile.partnerSlug === 'manual-florist-global-v1') {
      if (window.FlorameLocalFlorist?.url) return window.FlorameLocalFlorist.url(profile);
      return (lang() === 'en' ? '/en' : '') + '/pages/florame-app?view=local-florist&partner=manual-florist-global-v1&city=' + encodeURIComponent(profile.city || '') + '&cap=' + encodeURIComponent(profile.cap || '');
    }
    var fallback = '/pages/' + encodeURIComponent(profile.partnerSlug || 'florame-app');
    try {
      var url = new URL(profile.homeUrl || profile.portal?.homeUrl || fallback, window.location.origin);
      if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return fallback;
      return url.pathname + url.search + url.hash;
    } catch (_) { return fallback; }
  }

  function renderFloristOverview(overlay, info) {
    var profile = info.selectedFlorist || {};
    var manual = profile.manualFallback === true || profile.partnerSlug === 'manual-florist-global-v1';
    var locked = info.selectionLocked === true;
    var name = String(profile.name || floristCopy('Il tuo fiorista', 'Your florist'));
    var logo = '';
    try {
      var logoUrl = new URL(profile.logoUrl, window.location.origin);
      if (profile.logoUrl && (/^https?:$/.test(logoUrl.protocol) || (manual && String(profile.logoUrl).startsWith('data:image/svg+xml;')))) logo = logoUrl.href;
    } catch (_) {}
    var prefix = lang() === 'en' ? '/en' : '';
    var pickup = info.selectionDeliveryType === 'pickup';
    var address = pickup ? String(profile.addressLine || floristCopy('Ritiro in negozio', 'In-store pickup')) : info.addressReady === false ? '' : String(info.address || info.cap || '');
    var results = overlay.querySelector('[data-partner-compare-results]');
    overlay.querySelector('[data-partner-compare-kicker]').textContent = floristCopy('La tua scelta', 'Your choice');
    overlay.querySelector('[data-partner-compare-subtitle]').textContent = '';
    overlay.querySelector('[data-partner-compare-context]').textContent = '';
    overlay.querySelector('[data-partner-compare-status]').textContent = '';
    results.innerHTML = '<div class="florame-florist-overview">' +
      '<div class="florame-florist-profile"><span class="florame-florist-avatar" aria-hidden="true">' + (logo ? '<img src="' + escapeHtml(logo) + '" alt="" width="64" height="64" decoding="async">' : escapeHtml(initials(name))) + '</span><div><span class="florame-florist-state">' + iconSvg(manual ? 'spark' : 'check') + escapeHtml(manual ? floristCopy('Su richiesta', 'On request') : floristCopy('Selezionato', 'Selected')) + '</span><h3>' + escapeHtml(name) + '</h3><p>' + escapeHtml(manual ? floristCopy('La richiesta è seguita da Florame', 'Florame takes care of your request') : String(profile.city || floristCopy('Il negozio per il tuo bouquet', 'The shop for your bouquet'))) + '</p></div></div>' +
      '<button type="button" class="florame-florist-delivery" data-florist-delivery>' + iconSvg(pickup ? 'store' : 'truck') + '<span><strong>' + escapeHtml(info.selectedSchedule || floristCopy('Dove e quando', 'Where and when')) + '</strong><em>' + escapeHtml(address || floristCopy('Scegli giorno e fascia', 'Choose the date and time')) + '</em></span><i>' + iconSvg('arrow') + '</i></button>' +
      '<div class="florame-florist-actions"><a class="florame-florist-shop" href="' + escapeHtml(floristShopUrl(profile)) + '">' + iconSvg('store') + '<span>' + escapeHtml(floristCopy('Esplora negozio', 'Explore shop')) + '</span></a><a href="' + prefix + '/pages/florame-messages?partner=' + encodeURIComponent(profile.partnerSlug || '') + '">' + iconSvg('chat') + '<span>' + escapeHtml(manual ? floristCopy('Scrivi a Florame', 'Contact Florame') : floristCopy('Messaggi', 'Messages')) + '</span></a></div>' +
      (manual ? '<details class="florame-florist-explainer"><summary>' + escapeHtml(floristCopy('Come funziona la richiesta?', 'How does a request work?')) + '</summary><p>' + escapeHtml(floristCopy('Florame cerca un fiorista in zona. La richiesta è confermata solo quando viene accettata. Trovi gli aggiornamenti nei Messaggi.', 'Florame looks for a florist nearby. Your request is confirmed only once it is accepted. Find updates in Messages.')) + '</p></details>' : '') +
      '<div class="florame-florist-switch"><h3>' + escapeHtml(locked ? floristCopy('Hai già un bouquet nel carrello', 'You have a bouquet in your cart') : floristCopy('Vuoi un altro fiorista?', 'Want a different florist?')) + '</h3><p>' + escapeHtml(locked ? floristCopy('Il carrello resta legato a questo negozio. Puoi esplorare gli altri; per cambiare, completa l’ordine o rimuovi prima i bouquet dal carrello.', 'Your cart stays with this shop. You can explore others; to switch, complete your order or remove the bouquets from your cart first.') : floristCopy('Confronta chi può prepararlo nella tua zona.', 'Compare florists who can prepare it in your area.')) + '</p>' +
      '<button type="button" class="florame-florist-alternatives" data-florist-alternatives><span>' + escapeHtml(locked ? floristCopy('Esplora altri negozi', 'Explore other shops') : floristCopy('Confronta fioristi', 'Compare florists')) + '</span>' + iconSvg('arrow') + '</button>' +
      (locked ? '<a class="florame-florist-cart" href="' + prefix + '/cart">' + escapeHtml(floristCopy('Vai al carrello', 'Go to cart')) + '</a>' : '<details class="florame-florist-explainer"><summary>' + escapeHtml(floristCopy('Cosa succede se cambio?', 'What happens if I switch?')) + '</summary><p>' + escapeHtml(floristCopy('Manteniamo la composizione e ricontrolliamo fiori, prezzi e fasce di consegna del nuovo negozio. La scelta è completa solo dopo questa verifica.', 'We keep your composition and check the new shop’s flowers, prices and delivery times. Your selection is complete only after this check.')) + '</p></details>') + '</div></div>';
    results.querySelector('[data-florist-delivery]').addEventListener('click', function () { editFloristDelivery(overlay, info); });
    results.querySelector('[data-florist-alternatives]').addEventListener('click', function () { openCompare(Object.assign({}, info, { showAlternatives: true })); });
  }

  function editFloristDelivery(overlay, info) {
    overlay.__closeFlorameCompare?.({ continuation: true });
    window.setTimeout(function () {
      if (info.onEditDelivery) info.onEditDelivery();
      else window.FlorameDeliveryIntent?.open({ opener: compareLastFocus, source: 'matched-florist' });
    }, 240);
  }

  // Pickup searches an area, never a verified delivery address or civic number.
  async function openPickupSearch(overlay, info, sequence, options = {}) {
    await window.__florameEnsureDirectoryStyles?.();
    if (document.hidden || !overlay.isConnected) return;
    var context = overlay.querySelector('[data-partner-compare-context]');
    var status = overlay.querySelector('[data-partner-compare-status]');
    var results = overlay.querySelector('[data-partner-compare-results]');
    overlay.querySelector('[data-pickup-title],#florame-partner-compare-title').textContent = floristCopy('Scegli dove ritirare', 'Choose a pickup shop');
    overlay.querySelector('[data-partner-compare-kicker]').textContent = '';
    overlay.querySelector('[data-partner-compare-subtitle]').textContent = floristCopy('Ogni ritiro richiede la conferma del fiorista.', 'Every pickup order requires the florist’s confirmation.');
    context.innerHTML = '<form class="florame-pickup-search" data-pickup-area><label for="floramePickupArea">' + escapeHtml(floristCopy('Città, CAP, via o fiorista', 'City, postcode, street or florist')) + '</label><div class="florame-pickup-search__field"><input id="floramePickupArea" type="search" inputmode="search" autocomplete="off" maxlength="180" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="floramePickupSuggestions" placeholder="' + escapeHtml(floristCopy('Es. Roma oppure Via Verdi', 'E.g. Rome or Via Verdi')) + '"><button type="submit" aria-label="' + escapeHtml(t('search')) + '">' + iconSvg('search') + '</button><button type="button" data-pickup-clear aria-label="' + escapeHtml(floristCopy('Mostra tutti i fioristi', 'Show all florists')) + '" hidden>×</button></div><ul id="floramePickupSuggestions" role="listbox" hidden></ul></form>';
    var input = context.querySelector('input'), suggestionsHost = context.querySelector('ul'), clear = context.querySelector('[data-pickup-clear]');
    var rows = [], shown = 24, suggestions = [], active = -1, timer = 0, revision = 0, disposed = false, loading = false, selecting = false;
    var directoryRequest, suggestRequest, resolveRequest;
    var profileRequests = new Map();
    var areaCache = new Map(), suggestionCache = new Map();
    var session = 'pickup_' + Date.now().toString(36) + Math.random().toString(36).slice(2);
    var live = function () { return !disposed && !overlay.hidden && (options.embedded ? overlay.isConnected && options.isLive() : sequence === compareTransitionSequence); };
    var eventRoot = options.eventRoot || overlay;
    function backFromSuggestions(event) { if (!suggestionsHost.hidden) { event.preventDefault(); hideSuggestions(); input.focus({preventScroll:true}); } }
    eventRoot.addEventListener('florame:sheet-back', backFromSuggestions);
    overlay.__pickupSearchCleanup = function () { disposed = true; clearTimeout(timer); directoryRequest?.abort(); suggestRequest?.abort(); resolveRequest?.abort(); profileRequests.forEach(controller=>controller.abort()); results.removeEventListener('toggle', loadMissingHours, true); results.onclick = null; eventRoot.removeEventListener('florame:sheet-back', backFromSuggestions); };
    async function loadMissingHours(event) {
      const details = event.target;
      if (!details.matches('details') || !details.open || !live()) return;
      const card = details.closest('[data-pickup-shop]'), slug = card?.dataset.pickupShop;
      const row = rows.find(row => row.partnerSlug === slug);
      if (!row || Object.prototype.hasOwnProperty.call(row, 'openingHours') || pickupPublicProfiles.has(slug) || profileRequests.has(slug)) return;
      const weekly = details.querySelector('.florame-pickup-shop__weekly');
      weekly.textContent = floristCopy('Carico gli orari…', 'Loading shop hours…');
      const controller = new AbortController(); profileRequests.set(slug,controller);
      try {
        const data = await fetchJson(API_BASE + '/portalResolveContext', {partnerSlug:slug}, controller.signal);
        if (!live() || !card.isConnected) return;
        if (!data?.partner) throw new Error('profile_missing');
        const profile = {openingHours:data.partner.openingHours || data.partner.hours || null};
        pickupPublicProfiles.set(slug,profile);Object.assign(row,profile);
        const hours = pickupHours(row);
        weekly.innerHTML = hours.weekly;
        if (!hours.weekly) weekly.textContent = hours.value;
      } catch (error) {
        if (live() && card.isConnected && error.name !== 'AbortError') weekly.textContent = floristCopy('Orari temporaneamente non disponibili. Chiama il negozio o riapri per riprovare.', 'Hours are temporarily unavailable. Call the shop or reopen to retry.');
      } finally { profileRequests.delete(slug); }
    }
    results.addEventListener('toggle', loadMissingHours, true);
    function hideSuggestions() {
      suggestionsHost.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1;
    }
    function showSuggestions(list) {
      suggestions = list; active = -1;
      suggestionsHost.innerHTML = list.map(function (item, index) { return '<li role="option" aria-selected="false" id="pickup-place-' + index + '" data-pickup-place="' + index + '">' + escapeHtml(item.text || item.mainText || '') + '</li>'; }).join('');
      suggestionsHost.hidden = !list.length; input.setAttribute('aria-expanded', String(!!list.length)); input.removeAttribute('aria-activedescendant');
    }
    function paintRows() {
      results.innerHTML = rows.slice(0, shown).map(pickupShopCard).join('') + (shown < rows.length ? '<button type="button" class="florame-pickup-more" data-pickup-more>' + escapeHtml(floristCopy('Altri fioristi', 'More florists')) + '</button>' : '');
    }
    async function loadArea(area) {
      var id = ++revision; directoryRequest?.abort(); directoryRequest = new AbortController();
      loading = true; results.setAttribute('aria-busy', 'true'); status.textContent = floristCopy('Cerco fioristi…', 'Finding florists…');
      if (!rows.length) results.innerHTML = '<div class="florame-pickup-placeholder" aria-hidden="true"><span></span><i></i><i></i><b></b></div>'.repeat(2);
      var key = JSON.stringify(area), cached = areaCache.get(key);
      try {
        var data = cached && Date.now() - cached.at < 30000 ? cached.data : await fetchJson(CONFIG.directoryEndpoint, Object.assign({ mode:'compare', fulfillmentMode:'pickup', limit:100, includeQaFixtures:includeQaFixtures() ? '1' : '' }, area), directoryRequest.signal);
        if (!live() || id !== revision) return;
        areaCache.set(key, {at:Date.now(), data:data});
        rows = (Array.isArray(data.partners) ? data.partners : []).filter(function (row) { return row.pickupEnabled === true && row.partnerSlug !== 'manual-florist-global-v1' && (!info.lockedPartnerSlug || row.partnerSlug === info.lockedPartnerSlug); });
        shown = 24; paintRows(); results.scrollTop = 0;
        status.textContent = rows.length ? floristCopy(rows.length === 1 ? '1 fiorista con ritiro' : rows.length + ' fioristi con ritiro', rows.length === 1 ? '1 florist offering pickup' : rows.length + ' florists offering pickup') : floristCopy('Nessun negozio trovato. Prova una città o una zona vicina.', 'No shops found. Try a city or a nearby area.');
        if (!rows.length) {
          results.innerHTML = '<div class="florame-pickup-empty">' + iconSvg('store') + '<button type="button" class="florame-pickup-more" data-pickup-reset>' + escapeHtml(floristCopy('Mostra tutti i fioristi', 'Show all florists')) + '</button></div>';
          results.querySelector('[data-pickup-reset]').onclick = function () { clearTimeout(timer); input.value = ''; clear.hidden = true; hideSuggestions(); areaCache.delete('{}'); input.focus({preventScroll:true}); loadArea({}); };
        }
      } catch (error) {
        if (!live() || id !== revision || error.name === 'AbortError') return;
        status.textContent = floristCopy('Non riusciamo a caricare i negozi.', 'We cannot load the shops.');
        results.innerHTML = '<button type="button" class="florame-pickup-more" data-pickup-retry>' + escapeHtml(floristCopy('Riprova', 'Try again')) + '</button>';
        results.querySelector('[data-pickup-retry]').onclick = function () { loadArea(area); };
      } finally { if (live() && id === revision) { loading = false; results.removeAttribute('aria-busy'); } }
    }
    async function suggest(query) {
      suggestRequest?.abort(); suggestRequest = new AbortController();
      if (query.length < 2 || /^\d{5}$/.test(query)) { showSuggestions([]); return []; }
      try {
        var list = suggestionCache.get(query);
        if (!list) {
          var data = await fetchJson(CONFIG.addressAutocompleteEndpoint, {q:query,limit:5,country:'IT',sessionToken:session}, suggestRequest.signal);
          list = (data.suggestions || []).filter(function (item) { return item.placeId; }).slice(0,5); suggestionCache.set(query,list);
        }
        if (!live() || input.value.trim() !== query) return null;
        showSuggestions(list); return list;
      } catch (error) {
        if (!live() || input.value.trim() !== query || error.name === 'AbortError') return null;
        showSuggestions([]); return [];
      }
    }
    async function choosePlace(item) {
      clearTimeout(timer); suggestRequest?.abort(); resolveRequest?.abort(); resolveRequest = new AbortController();
      var resolving = ++revision; directoryRequest?.abort(); loading = true; results.setAttribute('aria-busy','true');
      hideSuggestions(); input.value = item.text || item.mainText; clear.hidden = false;
      var query = input.value;
      status.textContent = floristCopy('Cerco in questa zona…', 'Searching this area…');
      try {
        var data = await fetchJson(CONFIG.addressResolveEndpoint, {placeId:item.placeId,country:'IT',sessionToken:session}, resolveRequest.signal);
        if (!live() || input.value !== query) return;
        var place = data.place || {}, city = getComponent(place.addressComponents,'locality') || getComponent(place.addressComponents,'postal_town') || getComponent(place.addressComponents,'administrative_area_level_3');
        var postcode = extractCap(place.postcode || place.postalCode || place.formattedAddress || '');
        if (!city && !postcode && !(Number.isFinite(place.lat) && Number.isFinite(place.lng))) throw new Error('area_unresolved');
        suggestionCache.clear();
        session = 'pickup_' + Date.now().toString(36) + Math.random().toString(36).slice(2);
        await loadArea({cap:postcode,city:city,lat:place.lat ?? '',lng:place.lng ?? ''});
      } catch (error) {
        if (live() && input.value === query && error.name !== 'AbortError') { status.textContent = floristCopy('Non riesco a trovare questa zona. Riprova la ricerca.', 'Could not locate this area. Try searching again.'); }
      } finally { if (live() && resolving === revision) { loading = false; results.removeAttribute('aria-busy'); } }
    }
    input.addEventListener('input', function () {
      clearTimeout(timer); suggestRequest?.abort(); resolveRequest?.abort(); directoryRequest?.abort(); revision++; loading = false; results.removeAttribute('aria-busy'); hideSuggestions(); suggestions = []; clear.hidden = !input.value;
      var query = input.value.trim();
      if (!query) { loadArea({}); return; }
      timer = setTimeout(function () { suggest(query); }, 300);
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !suggestionsHost.hidden) { event.preventDefault(); event.stopPropagation(); hideSuggestions(); return; }
      if (!suggestions.length || suggestionsHost.hidden || !['ArrowDown','ArrowUp','Enter'].includes(event.key)) return;
      if (event.key === 'Enter') { if (active >= 0) { event.preventDefault(); choosePlace(suggestions[active]); } return; }
      event.preventDefault(); active = (active + (event.key === 'ArrowDown' ? 1 : -1) + suggestions.length) % suggestions.length;
      Array.from(suggestionsHost.children).forEach(function (item,index) { item.setAttribute('aria-selected', String(index === active)); });
      input.setAttribute('aria-activedescendant', 'pickup-place-' + active); suggestionsHost.children[active].scrollIntoView({block:'nearest'});
    });
    suggestionsHost.addEventListener('click', function (event) { var item = event.target.closest('[data-pickup-place]'); if (item) choosePlace(suggestions[Number(item.dataset.pickupPlace)]); });
    context.querySelector('form').addEventListener('submit', async function (event) {
      event.preventDefault(); clearTimeout(timer); var query = input.value.trim();
      if (!query || /^\d{5}$/.test(query)) { hideSuggestions(); return loadArea(query ? {cap:query} : {}); }
      status.textContent = floristCopy('Cerco questa zona…', 'Searching this area…');
      var list = await suggest(query); if (!live() || list === null) return;
      if (list.length === 1) return choosePlace(list[0]);
      if (list.length > 1) { status.textContent = floristCopy('Scegli il luogo tra i suggerimenti.', 'Choose a place from the suggestions.'); return; }
      hideSuggestions(); return loadArea({search:query});
    });
    clear.addEventListener('click', function () { input.value = ''; input.dispatchEvent(new Event('input')); input.focus(); });
    results.onclick = async function (event) {
      if (!live()) return;
      var more = event.target.closest('[data-pickup-more]');
      if (more) {
        var previous = shown; shown += 24;
        more.insertAdjacentHTML('beforebegin', rows.slice(previous,shown).map(pickupShopCard).join(''));
        if (shown >= rows.length) { more.remove(); results.querySelectorAll('[data-pickup-select]')[previous]?.focus({preventScroll:true}); }
        return;
      }
      var button = event.target.closest('[data-pickup-select]'); if (!button || loading || selecting) return;
      var selected = rows.find(function (row) { return row.partnerSlug === button.dataset.partnerSlug; }); if (!selected) return;
      selecting = true; results.setAttribute('aria-busy','true'); button.disabled = true;
      const originalLabel = button.querySelector('span').textContent;
      button.setAttribute('aria-busy','true');button.querySelector('span').textContent = floristCopy('Verifico il negozio…', 'Checking this shop…');
      button.closest('[data-pickup-shop]')?.setAttribute('data-selecting','true');
      results.querySelectorAll('[data-pickup-select]').forEach(item=>item.setAttribute('aria-disabled','true'));
      status.textContent = floristCopy('Imposto il ritiro…', 'Setting up pickup…');
      try {
        if (typeof info.onSelectPartner === 'function') await info.onSelectPartner(selected);
        else { var target = new URL(selected.homeUrl || '/pages/' + encodeURIComponent(selected.partnerSlug),location.origin); if (target.origin === location.origin) location.assign(target.pathname + target.search); }
      } catch (error) { if (live()) status.textContent = error.message || t('addressError'); }
      finally {
        if (live()) {
          selecting = false; button.disabled = false;
          button.removeAttribute('aria-busy'); button.querySelector('span').textContent = originalLabel;
          button.closest('[data-pickup-shop]')?.removeAttribute('data-selecting');
          results.querySelectorAll('[data-pickup-select]').forEach(item=>item.removeAttribute('aria-disabled'));
          results.removeAttribute('aria-busy');
        }
      }
    };
    input.value = info.address || info.city || info.cap || ''; clear.hidden = !input.value;
    return loadArea(info.cap || info.city || info.lat ? {cap:info.cap || '',city:info.city || '',lat:info.lat ?? '',lng:info.lng ?? ''} : {});
  }

  async function openCompare(detail) {
    await window.__florameEnsureDirectoryStyles?.();
    if (document.hidden || (detail?.opener && !detail.opener.isConnected)) return;
    var overlay = ensureCompareSheet();
    overlay.__pickupSearchCleanup?.();
    overlay.__pickupSearchCleanup = null;
    var info = detail && typeof detail === 'object' ? detail : {};
    compareCurrentDetail = info;
    var saved = ['matched-florist', 'where-when-pickup'].includes(info.source) ? {} : readSavedCapState() || {};
    var cap = String(info.cap || saved.cap || '').trim();
    var address = String(info.address || info.display || saved.address || '').trim();
    var currentSlug = currentPartnerSlug(info);
    var compareSource = String(info.source || '').trim().toLowerCase();
    var compareIntent = String(info.intent || info.compareIntent || '').trim().toLowerCase();
    var commerceMissing = info.commerceMissing === true || String(info.commerceMissing || '') === '1';
    var productIntent = compareIntent === 'product'
      || compareIntent === 'offer'
      || compareIntent === 'purchase'
      || !!String(info.productId || '').trim()
      || !!info.offerResolution;
    if (info.selectionLocked === true) productIntent = false;
    var coverageFailure = compareIntent === 'coverage'
      || String(info.coverageState || '').trim().toLowerCase() === 'uncovered'
      || compareSource === 'coverage-failed'
      || compareSource === 'bouquet-outside-coverage'
      || compareSource === 'pdp-coverage'
      || compareSource === 'pdp-coverage-failed';
    var kicker = overlay.querySelector('[data-partner-compare-kicker]');
    var title = overlay.querySelector('#florame-partner-compare-title');
    var subtitle = overlay.querySelector('[data-partner-compare-subtitle]');
    var context = overlay.querySelector('[data-partner-compare-context]');
    var status = overlay.querySelector('[data-partner-compare-status]');
    var results = overlay.querySelector('[data-partner-compare-results]');

    if (overlay.hidden) {
      var opener = info.opener || info.button;
      compareLastFocus = typeof opener?.focus === 'function' ? opener : document.activeElement;
      compareBodyOverflow = document.body.style.overflow || '';
    }
    document.body.style.overflow = 'hidden';
    var requestSequence = ++compareTransitionSequence;
    overlay.hidden = false;
    overlay.setAttribute('data-compare-intent', productIntent ? 'product' : (coverageFailure ? 'coverage' : 'choice'));
    overlay.setAttribute('data-compare-source', compareSource);
    window.requestAnimationFrame(function () { if (requestSequence === compareTransitionSequence) overlay.classList.add('is-open'); });
    var hasSelectedFlorist = !!String(info.selectedFlorist?.partnerSlug || '').trim();
    var overview = compareSource === 'matched-florist' && hasSelectedFlorist && !info.showAlternatives;
    overlay.dataset.floristView = overview ? 'overview' : 'alternatives';
    var back = overlay.querySelector('[data-florist-back]');
    back.hidden = !(compareSource === 'matched-florist' && hasSelectedFlorist && info.showAlternatives);
    back.innerHTML = iconSvg('arrow') + '<span>' + escapeHtml(floristCopy('Il tuo fiorista', 'Your florist')) + '</span>';
    back.onclick = function () { openCompare(Object.assign({}, info, { showAlternatives: false })); };
    if (kicker) kicker.textContent = t(commerceMissing ? 'offerGoneKicker' : (productIntent ? 'offerKicker' : (coverageFailure ? 'compareCoverageKicker' : 'compareChoiceKicker')));
    if (title) title.textContent = t(commerceMissing ? 'offerGoneTitle' : (productIntent ? 'offerTitle' : (coverageFailure ? 'compareCoverageTitle' : 'compareChoiceTitle')));
    if (subtitle) subtitle.textContent = t(commerceMissing ? 'offerGoneSubtitle' : (productIntent ? 'offerSubtitle' : (coverageFailure ? 'compareCoverageSubtitle' : 'compareChoiceSubtitle')));
    if (subtitle && info.preserveCart === true) subtitle.textContent = floristCopy('Apri un negozio che consegna al nuovo indirizzo. Il carrello attuale resta salvato con il suo fiorista; i nuovi bouquet saranno verificati con il nuovo negozio.', 'Open a shop that delivers to the new address. Your current cart stays saved with its florist; new bouquets will be checked with the new shop.');
    if (context) context.textContent = [String(info.productName || '').trim(), address || cap || ''].filter(Boolean).join(' · ');
    if (productIntent && context) {
      var contextLabel = info.selectionDeliveryType === 'pickup' ? floristCopy('Zona di ricerca', 'Search area') : floristCopy('Indirizzo di consegna', 'Delivery address');
      context.innerHTML = (info.productName ? '<strong>' + escapeHtml(info.productName) + '</strong>' : '') +
        (address || cap ? '<details class="florame-partner-offer-address"><summary>' + iconSvg('locate') + '<span>' + escapeHtml(contextLabel) + '</span></summary><p>' + escapeHtml(address || cap) + '</p></details>' : '');
    }
    if (status) status.textContent = cap ? t('searching') : t('compareAddressRequired');
    if (results) results.innerHTML = '';
    results?.removeAttribute('aria-busy');
    if (info.source === 'matched-florist') {
      if (title) title.textContent = info.showAlternatives ? floristCopy('Altri fioristi', 'Other florists') : floristCopy('Il tuo fiorista', 'Your florist');
      if (subtitle) subtitle.textContent = info.selectionLocked === true
        ? floristCopy('Esplora gli altri negozi. I bouquet nel carrello restano con il fiorista già scelto.', 'Explore other shops. Your cart’s bouquets stay with your selected florist.')
        : (lang() === 'en' ? 'Choose who prepares your bouquet. We will check prices, flowers and delivery times again, keeping your composition.' : 'Scegli chi prepara il bouquet. Ricontrolliamo prezzi, fiori e fasce di consegna mantenendo la tua composizione.');
      if (context) {
        context.textContent = '';
        var placeLabel = document.createElement('span'); placeLabel.textContent = address || cap;
        context.appendChild(placeLabel);
        var schedule = document.createElement('button'); schedule.type = 'button';
        schedule.className = 'florame-partner-compare-address';
        schedule.textContent = lang() === 'en' ? 'Edit' : 'Modifica';
        schedule.setAttribute('aria-label', lang() === 'en' ? 'Edit where and when' : 'Modifica dove e quando');
        schedule.addEventListener('click', function () { editFloristDelivery(overlay, info); });
        context.appendChild(schedule);
      }
    }

    var close = overlay.querySelector('.florame-partner-compare-close');
    overlay.querySelector('.florame-partner-compare-sheet').scrollTop = 0;
    if (close) window.setTimeout(function () { if (requestSequence === compareTransitionSequence) (back.hidden ? close : back).focus({ preventScroll: true }); }, 60);
    if (overview) { comparePendingDetail = null; renderFloristOverview(overlay, info); return; }

    if (compareSource === 'where-when-pickup') {
      comparePendingDetail = null;
      return openPickupSearch(overlay, info, requestSequence);
    }

    if (!cap && !commerceMissing && !bouquetOrderIssue(info.offerResolution) && !(info.selectionDeliveryType === 'pickup' && info.offerResolution?.offers?.length)) {
      comparePendingDetail = compareSource === 'matched-florist' ? null : info;
      if (results) {
        results.innerHTML = '<button type="button" class="florame-partner-compare-address" data-partner-compare-address>' +
          iconSvg('locate') + '<span>' + escapeHtml(t('compareAddAddress')) + '</span></button>';
        var addressButton = results.querySelector('[data-partner-compare-address]');
        if (addressButton) addressButton.addEventListener('click', async function () {
          if (compareSource === 'matched-florist') { editFloristDelivery(overlay, info); return; }
          addressButton.disabled = true;
          try {
            var intent = window.FlorameDeliveryIntent || await window.__florameLoadDeliveryIntent?.();
            if (intent?.open) {
              comparePendingDetail = null;
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare({ continuation: true });
              window.setTimeout(function () {
                intent.open({
                  opener: compareLastFocus, source: 'partner-compare',
                  onConfirm: function () {
                    var state = intent.get({ fresh: true });
                    return openCompare(Object.assign({}, info, {
                      cap: state.address?.postalCode || '', address: state.address?.display || '',
                      city: state.address?.city || '', lat: state.address?.latitude ?? '', lng: state.address?.longitude ?? '',
                      selectionDeliveryType: state.deliveryType, offerResolution: null, bypassCache: true
                    }));
                  }
                });
              }, 240);
              return;
            }
          } catch (_) {
            if (status) status.textContent = floristCopy('Non riesco ad aprire Dove e quando. Riprova.', 'Unable to open Where and when. Try again.');
            return;
          } finally { addressButton.disabled = false; }
          if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare({ continuation: true });
          window.setTimeout(function () {
            if (window.FlorameHomeAddress && typeof window.FlorameHomeAddress.open === 'function') {
              window.FlorameHomeAddress.open({ source: 'partner-compare', scroll: true, focus: true });
              return;
            }
            var trigger = document.querySelector('[data-home-address-trigger="header"], [data-home-address-trigger]');
            if (trigger) trigger.click();
            else openCompare(info);
          }, 240);
        });
      }
      return;
    }
    comparePendingDetail = null;

    try {
      var data = commerceMissing
        ? { partners: [], resolutions: {}, resolution: null }
        : info.offerResolution
        ? { partners: [], resolution: info.offerResolution }
        : productIntent
        ? await resolveOffers(info)
        : await fetchJson(CONFIG.directoryEndpoint, {
            mode: 'compare',
            cap: cap,
            address: address,
            city: info.city || '',
            lat: info.lat || '',
            lng: info.lng || '',
            productId: info.productId || '',
            currentPartnerSlug: currentSlug,
            fulfillmentMode: info.selectionDeliveryType || 'delivery',
            includeQaFixtures: includeQaFixtures() ? '1' : '',
            limit: 20
          });
      if (requestSequence !== compareTransitionSequence) return;
      var resolution = commerceMissing
        ? { productId: String(info.productId || '').trim(), state: 'commerce_missing', offers: [] }
        : info.offerResolution
        || data.resolution
        || data.resolutions && data.resolutions[String(info.productId || '').trim()]
        || null;
      var offers = resolution && Array.isArray(resolution.offers) ? resolution.offers : [];
      offers = offers.filter(function (offer) { return offer.variantId && ['instant','request'].includes(String(offer.fulfillmentOffer?.mode || offer.offer?.mode || '')); });
      if (info.selectionDeliveryType) offers = offers.filter(function (offer) { return (offer.fulfillmentType || 'delivery') === info.selectionDeliveryType; });
      var pricingPreparing = String(resolution && resolution.state || '').toLowerCase() === 'pricing_preparing';
      var orderIssue = !offers.length ? bouquetOrderIssue(resolution) : '';
      if (orderIssue && title) title.textContent = floristCopy('Il bouquet va aggiornato', 'Update this bouquet');
      var offerGroups = groupOffersByPartner(offers);
      var currentPartner = currentSlug
        ? (Array.isArray(data.partners) ? data.partners : []).find(function (partner) {
            return String(partner && partner.partnerSlug || '').trim().toLowerCase() === currentSlug;
          })
        : null;
      var currentProductId = String(info.productId || resolution && resolution.productId || '').trim();
      var currentBouquetMatch = currentPartner && currentProductId
        ? currentPartner.bouquetMatches && currentPartner.bouquetMatches[currentProductId]
        : currentPartner && currentPartner.bouquetMatch;
      var canNotifyCurrent = !!(
        currentPartner
        && String(currentBouquetMatch && currentBouquetMatch.state || '').toLowerCase() === 'unavailable'
      );
      if (productIntent && resolution) {
        if (status) {
          status.textContent = orderIssue || (commerceMissing
            ? t('offerGoneStatus')
            : pricingPreparing
              ? t('offerPricingPreparing')
            : (offerGroups.length === 1
              ? ''
              : (offerGroups.length ? offerGroups.length + ' ' + t('offerFloristMany') : t('offerEmpty'))));
        }
        if (results) {
          results.innerHTML = offers.map(function (offer, index) {
            var profile = Object.assign({}, offer.partner, {bouquetMatch:null,deliveryEnabled:offer.fulfillmentType === 'delivery',pickupEnabled:offer.fulfillmentType === 'pickup'});
            return partnerCard(profile, 'coverage', {compact:true,currentSlug:currentSlug,purchaseOffer:offer,offerIndex:index});
          }).join('') +
            (pricingPreparing
              ? '<div class="florame-partner-compare-empty" role="status">' +
                  '<p>' + escapeHtml(t('offerPricingPreparingHint')) + '</p>' +
                  '<button type="button" class="florame-partner-compare-address" data-partner-offer-retry>' +
                    iconSvg('search') + '<span>' + escapeHtml(t('offerRetry')) + '</span></button></div>'
              : '') +
            (!offers.length && !commerceMissing && !orderIssue && !pricingPreparing
              ? '<button type="button" class="florame-partner-compare-address" data-partner-compare-address>' +
                  iconSvg('locate') + '<span>' + escapeHtml(t('offerChangeAddress')) + '</span></button>'
              : '') +
            (canNotifyCurrent
              ? '<button type="button" class="florame-partner-compare-notify" data-partner-offer-notify>' +
                  iconSvg('bell') + '<span>' + escapeHtml(t('offerNotify')) + '</span></button>'
              : '') +
            (!pricingPreparing && !offers.length
              ? '<button type="button" class="florame-partner-compare-create" data-partner-compare-create>' +
                iconSvg('spark') + '<span>' + escapeHtml(t(info.bouquetData && typeof window.homeEditBouquet === 'function' ? 'offerEdit' : 'offerCreateNew')) + '</span></button>'
              : '');
          results.querySelectorAll('[data-florame-offer-index]').forEach(function (button) {
            button.addEventListener('click', function () {
              var offer = offers[Number(button.getAttribute('data-florame-offer-index') || 0)] || null;
              if (!offer) return;
              if (typeof info.onSelectOffer === 'function') {
                if (results.getAttribute('aria-busy') === 'true') return;
                results.setAttribute('aria-busy', 'true');
                if (status) status.textContent = lang() === 'en' ? 'Checking florist and price…' : 'Verifico fiorista e prezzo…';
                Promise.resolve().then(function () { return info.onSelectOffer(offer); }).then(function (added) {
                  if (added === true && info.closeAfterOfferSelection === true && requestSequence === compareTransitionSequence) overlay.__closeFlorameCompare?.({ continuation: true });
                }).catch(function (error) {
                  if (requestSequence === compareTransitionSequence && status) status.textContent = error.message || t('addressError');
                }).finally(function () { if (requestSequence === compareTransitionSequence) results.removeAttribute('aria-busy'); });
                return;
              }
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare({ continuation: true });
              window.setTimeout(function () {
                window.dispatchEvent(new CustomEvent('florame:bouquet-offer-selected', {
                  detail: {
                    offer: offer,
                    resolution: resolution,
                    productId: String(info.productId || offer.productId || ''),
                    variantId: String(info.variantId || offer.variantId || ''),
                    handle: String(info.handle || offer.handle || ''),
                    productName: String(info.productName || offer.bouquetName || ''),
                    button: info.button || null,
                    suppressAutoAdd: info.suppressAutoAdd === true,
                    source: String(info.source || 'offer-sheet')
                  }
                }));
              }, 230);
            });
          });
          var addressButton = results.querySelector('[data-partner-compare-address]');
          if (addressButton) addressButton.addEventListener('click', async function () {
            try {
              var intent = window.FlorameDeliveryIntent || await window.__florameLoadDeliveryIntent?.();
              if (!intent?.open) throw new Error('intent_unavailable');
              await window.FloramePartnerDirectory.closeCompare({continuation:true,restoreFocus:false});
              intent.open({opener:info.opener || info.button,source:'partner-compare',onDismiss:info.onDismiss,onConfirm:function () {
                var state = intent.get({fresh:true});
                return openCompare(Object.assign({}, info, {cap:state.address?.postalCode || '',address:state.address?.display || '',city:state.address?.city || '',lat:state.address?.latitude ?? '',lng:state.address?.longitude ?? '',selectionDeliveryType:state.deliveryType,offerResolution:null,bypassCache:true}));
              }});
            } catch (_) { if (requestSequence === compareTransitionSequence) status.textContent = floristCopy('Non riesco ad aprire Dove e quando. Riprova.', 'Unable to open Where and when. Try again.'); }
          });
          var retryButton = results.querySelector('[data-partner-offer-retry]');
          if (retryButton) retryButton.addEventListener('click', function () {
            retryButton.disabled = true;
            retryButton.setAttribute('aria-busy', 'true');
            window.setTimeout(function () { if (requestSequence === compareTransitionSequence) openCompare(info); }, 450);
          });
          var notifyButton = results.querySelector('[data-partner-offer-notify]');
          if (notifyButton) notifyButton.addEventListener('click', function () {
            if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
            window.setTimeout(function () {
              window.dispatchEvent(new CustomEvent('florame:bouquet-offer-notify', {
                detail: {
                  productId: currentProductId,
                  variantId: String(info.variantId || ''),
                  handle: String(info.handle || ''),
                  productName: String(info.productName || ''),
                  partner: currentPartner,
                  button: info.button || null,
                  source: String(info.source || 'offer-sheet')
                }
              }));
            }, 230);
          });
          var createOfferButton = results.querySelector('[data-partner-compare-create]');
          if (createOfferButton) createOfferButton.addEventListener('click', function () {
            var bouquetData = String(info.bouquetData || '');
            if (bouquetData && typeof window.homeEditBouquet === 'function') {
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
              window.setTimeout(function () { window.homeEditBouquet(bouquetData); }, 220);
              return;
            }
            var destination = window.FloramePartner && typeof window.FloramePartner.appUrl === 'function'
              ? window.FloramePartner.appUrl('custom')
              : '/pages/florame-app?mode=custom';
            window.location.assign(destination);
          });
        }
        return;
      }
      var partners = Array.isArray(data.partners) ? data.partners.slice() : [];
      if (info.selectionDeliveryType === 'pickup') partners = partners.filter(function (row) { return row.pickupEnabled === true && row.partnerSlug !== 'manual-florist-global-v1'; });
      if (compareSource === 'matched-florist' && window.FlorameLocalFlorist) partners = partners.map(function (row) {
        return row.partnerSlug === window.FlorameLocalFlorist.slug
          ? Object.assign({}, row, window.FlorameLocalFlorist.identity({ city:info.city, cap:cap }), { homeUrl:window.FlorameLocalFlorist.url({ city:info.city, cap:cap }) }) : row;
      });
      if (productIntent) {
        partners = partners.filter(function (partner) {
          var slug = String(partner && partner.partnerSlug || '').toLowerCase();
          var match = String(partner && partner.bouquetMatch && partner.bouquetMatch.state || '').toLowerCase();
          return slug !== currentSlug && match !== 'unavailable';
        });
      }
      partners.sort(function (left, right) {
        var leftCurrent = String(left && left.partnerSlug || '').toLowerCase() === currentSlug ? 1 : 0;
        var rightCurrent = String(right && right.partnerSlug || '').toLowerCase() === currentSlug ? 1 : 0;
        return rightCurrent - leftCurrent;
      });
      if (status) {
        if (compareSource === 'where-when-pickup') status.textContent = partners.length ? '' : floristCopy('Nessun negozio con ritiro trovato in questa zona. Prova un altro CAP.', 'No pickup shops found in this area. Try another postal code.');
        else if (!partners.length) status.textContent = t(productIntent ? 'compareProductEmpty' : 'compareEmpty');
        else if (partners.length === 1 && String(partners[0].partnerSlug || '').toLowerCase() === currentSlug) status.textContent = t('compareOnly');
        else if (partners.length === 1) status.textContent = t('compareOneAlternative');
        else status.textContent = t('compareMany');
      }
      if (results) {
        results.innerHTML = partners.map(function (partner) {
          return compareSource === 'where-when-pickup' ? pickupShopCard(partner) : partnerCard(partner, 'coverage', { compact: true, currentSlug: currentSlug });
        }).join('') + (productIntent
          ? '<button type="button" class="florame-partner-compare-create" data-partner-compare-create>' +
              iconSvg('arrow') + '<span>' + escapeHtml(t('offerCreateNew')) + '</span></button>'
          : '');
        var createButton = results.querySelector('[data-partner-compare-create]');
        if (createButton) createButton.addEventListener('click', function () {
          var bouquetData = String(info.bouquetData || '');
          if (bouquetData && typeof window.homeEditBouquet === 'function') {
            if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
            window.setTimeout(function () { window.homeEditBouquet(bouquetData); }, 220);
            return;
          }
          var destination = window.FloramePartner && typeof window.FloramePartner.appUrl === 'function'
            ? window.FloramePartner.appUrl('custom')
            : '/pages/florame-app?mode=custom';
          window.location.assign(destination);
        });
        results.querySelectorAll('a[data-partner-slug], button[data-pickup-select]').forEach(function (link) {
          var productId = String(info.productId || '').trim();
          if (productId && info.selectionLocked !== true && /^\/products\//i.test(window.location.pathname || '')) {
            try {
              var productUrl = new URL(window.location.href);
              productUrl.searchParams.set('partner', String(link.getAttribute('data-partner-slug') || ''));
              link.href = productUrl.pathname + productUrl.search + productUrl.hash;
            } catch (_) {}
          }
          link.addEventListener('click', function (event) {
            var nextSlug = String(link.getAttribute('data-partner-slug') || '');
            if (!nextSlug || (nextSlug === currentSlug && compareSource !== 'where-when-pickup')) {
              event.preventDefault();
              if (overlay.__closeFlorameCompare) overlay.__closeFlorameCompare();
              return;
            }
            if (typeof info.onSelectPartner === 'function' && info.selectionLocked !== true && !productIntent) {
              event.preventDefault();
              if (results.getAttribute('aria-busy') === 'true') return;
              var selectedPartner = partners.find(function (row) { return row.partnerSlug === nextSlug; });
              results.setAttribute('aria-busy', 'true');
              if (status) status.textContent = compareSource === 'where-when-pickup' ? floristCopy('Apro il negozio per il ritiro…', 'Opening the shop for pickup…') : floristCopy('Verifico fiori, prezzi e consegna…', 'Checking flowers, prices and delivery…');
              Promise.resolve().then(function () { return info.onSelectPartner(selectedPartner); }).catch(function (error) {
                if (requestSequence === compareTransitionSequence && status) status.textContent = error.message || t('addressError');
              }).finally(function () { if (requestSequence === compareTransitionSequence) results.removeAttribute('aria-busy'); });
              return;
            }
            if (productIntent && info.bouquetData) {
              event.preventDefault();
              try {
                var bouquet = JSON.parse(decodeURIComponent(String(info.bouquetData || '')));
                localStorage.setItem('florame_temp_edit', JSON.stringify({
                  composition: bouquet.composition || {},
                  packaging: bouquet.packaging || {},
                  fromHome: true,
                  seed: bouquet.seed,
                  promptData: bouquet.promptData
                }));
                var customUrl = new URL('/pages/florame-app', window.location.origin);
                customUrl.searchParams.set('mode', 'custom');
                customUrl.searchParams.set('action', 'edit_temp');
                customUrl.searchParams.set('partner', nextSlug);
                window.dispatchEvent(new CustomEvent('florame:partner-switching', {
                  detail: { currentPartnerSlug: currentSlug, requestedPartnerSlug: nextSlug, reason: 'bouquet_alternative' }
                }));
                window.location.assign(customUrl.pathname + customUrl.search);
                return;
              } catch (_) {}
            }
            if (link.matches('[data-pickup-select]')) {
              var selected = partners.find(function (row) { return row.partnerSlug === nextSlug; });
              if (selected) window.location.assign(floristShopUrl(selected));
            }
            window.dispatchEvent(new CustomEvent('florame:partner-switching', {
              detail: { currentPartnerSlug: currentSlug, requestedPartnerSlug: nextSlug, reason: 'customer_compare' }
            }));
          });
        });
      }
    } catch (_) {
      if (requestSequence !== compareTransitionSequence) return;
      if (status) status.textContent = compareSource === 'where-when-pickup' ? floristCopy('Non riusciamo a caricare i negozi. Riprova tra poco.', 'We cannot load the shops. Please try again shortly.') : t('addressError');
      if (results) {
        results.innerHTML = '<button type="button" class="florame-partner-compare-address" data-florist-retry>' + escapeHtml(floristCopy('Riprova', 'Try again')) + '</button>';
        results.querySelector('[data-florist-retry]').onclick = function () { openCompare(info); };
      }
    }
  }

  function wire(root) {
    if (!root || root.__floramePartnerDirectoryReady) return;
    root.__floramePartnerDirectoryReady = true;
    var surface = root.getAttribute('data-florame-partner-directory-surface') || '';
    root.innerHTML = shell(surface);

    var form = root.querySelector('[data-partner-directory-form]');
    var input = root.querySelector('[data-partner-directory-input]');
    var geo = root.querySelector('[data-partner-directory-geo]');
    var expand = root.querySelector('[data-partner-directory-expand]');

    if (expand) {
      expand.addEventListener('click', function () {
        var nextExpanded = root.getAttribute('data-directory-expanded') !== 'true';
        root.setAttribute('data-directory-expanded', nextExpanded ? 'true' : 'false');
        expand.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        expand.textContent = t(nextExpanded ? 'collapse' : 'viewAll');
        if (root.__floramePartnerDirectoryData) renderData(root, root.__floramePartnerDirectoryData);
      });
    }

    if (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        var query = input ? input.value : '';
        renderLoading(root, t('searching'));
        var resolved = await resolveAddressQuery(query);
        if (!resolved.cap && !resolved.city && !resolved.address) {
          var status = root.querySelector('[data-partner-directory-status]');
          if (status) status.textContent = t('addressError');
          return;
        }
        await loadDirectory(root, resolved, t('searching'));
      });
    }

    if (geo) {
      geo.addEventListener('click', function () {
        if (!navigator.geolocation) {
          var status = root.querySelector('[data-partner-directory-status]');
          if (status) status.textContent = t('gpsError');
          return;
        }
        renderLoading(root, t('searching'));
        navigator.geolocation.getCurrentPosition(function (position) {
          loadDirectory(root, {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }, t('searching'));
        }, function () {
          var status = root.querySelector('[data-partner-directory-status]');
          var results = root.querySelector('[data-partner-directory-results]');
          if (status) status.textContent = t('gpsError');
          if (results) results.innerHTML = '';
        }, { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 });
      });
    }

    var saved = readSavedCapState();
    if (saved && saved.cap) {
      if (input && saved.address) input.value = saved.address;
      loadDirectory(root, saved, t('loading'));
    } else {
      loadDirectory(root, {}, t('loading'));
    }
  }

  function boot() {
    var roots = Array.from(document.querySelectorAll('[data-florame-partner-directory-root]'));
    if (!roots.length) return;
    if (isPartnerRoute()) {
      roots.forEach(function (root) {
        root.hidden = true;
        var section = root.closest('[data-florame-partner-directory-section]');
        if (section) section.hidden = true;
      });
      return;
    }
    roots.forEach(wire);
  }

  window.addEventListener('florame:native-language-change', function () {
    var roots = Array.from(document.querySelectorAll('[data-florame-partner-directory-root]'));
    if (isPartnerRoute()) {
      roots.forEach(function (root) {
        root.hidden = true;
        var section = root.closest('[data-florame-partner-directory-section]');
        if (section) section.hidden = true;
      });
      return;
    }
    roots.forEach(function (root) {
      root.__floramePartnerDirectoryReady = false;
      wire(root);
    });
  });

  function handleCompareOpen(event) {
    openCompare(event && event.detail || {}).catch(function () {
      window.FlorameUI?.toast?.({tone:'error',detail:floristCopy('Non riesco ad aprire i fioristi. Riprova.', 'Cannot open florists. Please try again.')});
    });
  }
  document.addEventListener('cap-check-finish', function () {
    if (!comparePendingDetail) return;
    var pending = comparePendingDetail;
    comparePendingDetail = null;
    window.setTimeout(function () { openCompare(pending); }, 320);
  });
  window.addEventListener('florame:partner-compare-open', handleCompareOpen);
  document.addEventListener('florame:partner-compare-open', handleCompareOpen);
  window.FloramePartnerDirectory = Object.assign(window.FloramePartnerDirectory || {}, {
    mountPickupSearch: function (root, info, options) { return openPickupSearch(root, info, null, { ...options, embedded: true }); },
    openCompare: openCompare,
    closeCompare: function (options) {
      if (!compareSheet?.classList.contains('is-open')) return Promise.resolve(true);
      return new Promise(function (resolve) { compareSheet.__closeFlorameCompare(Object.assign({}, options, {onClosed:resolve})); });
    },
    resolveOffers: resolveOffers
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
